webpackJsonp([114276838955818,60335399758886],{

/***/ 180:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(280);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(180);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(78);
	var isArguments = __webpack_require__(77);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 77:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 78:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(51);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(57);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(56);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(157);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(156);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	if (typeof window !== "undefined" && window.IntersectionObserver) {
	  io = new window.IntersectionObserver(function (entries) {
	    entries.forEach(function (entry) {
	      listeners.forEach(function (l) {
	        if (l[0] === entry.target) {
	          // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	          if (entry.isIntersecting || entry.intersectionRatio > 0) {
	            io.unobserve(l[0]);
	            l[1]();
	          }
	        }
	      });
	    });
	  }, { rootMargin: "200px" });
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  io.observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var Img = function Img(props) {
	  var opacity = props.opacity,
	      onLoad = props.onLoad,
	      _props$transitionDela = props.transitionDelay,
	      transitionDelay = _props$transitionDela === undefined ? "" : _props$transitionDela,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["opacity", "onLoad", "transitionDelay"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: {
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      transitionDelay: transitionDelay,
	      opacity: opacity,
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }
	  }));
	};
	
	Img.propTypes = {
	  opacity: _propTypes2.default.number,
	  transitionDelay: _propTypes2.default.string,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden",
	              zIndex: 1
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement("div", {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        zIndex: 1,
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.35s"
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: ""
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func
	};
	
	exports.default = Image;

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

	module.exports = isFunction
	
	var toString = Object.prototype.toString
	
	function isFunction (fn) {
	  var string = toString.call(fn)
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	};


/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(81);
	
	function isObjectObject(o) {
	  return isObject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	module.exports = function isPlainObject(o) {
	  var ctor,prot;
	
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	};


/***/ }),

/***/ 81:
/***/ (function(module, exports) {

	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};


/***/ }),

/***/ 360:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(105);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(76);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(94);
	
	var _HelmetConstants = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(8);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(79);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(110);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(1).any;
	
	exports.default = function (css) {
	  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    if (typeof tag !== 'string' && typeof tag !== 'function') {
	      // $FlowInvalidInputTest
	      throw new Error('Cannot create styled-component for component: ' + tag);
	    }
	
	    /* This is callable directly as a template function */
	    var templateFunction = function templateFunction(strings) {
	      for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        interpolations[_key - 1] = arguments[_key];
	      }
	
	      return componentConstructor(tag, options, css.apply(undefined, [strings].concat(interpolations)));
	    };
	
	    /* If config methods are called, wrap up a new template function and merge options */
	    templateFunction.withConfig = function (config) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
	    };
	    templateFunction.attrs = function (attrs) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
	        attrs: _extends({}, options.attrs || {}, attrs) }));
	    };
	
	    return templateFunction;
	  };
	
	  return constructWithOptions;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _interleave = __webpack_require__(125);
	
	var _interleave2 = _interopRequireDefault(_interleave);
	
	var _flatten = __webpack_require__(47);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_RuleSet = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_RuleSet || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(1).any;
	
	exports.default = function (strings) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  return (0, _flatten2.default)((0, _interleave2.default)(strings, interpolations));
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _hash = __webpack_require__(20);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _StyleSheet = __webpack_require__(7);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Stringifier = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_Stringifier || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(1).any;
	
	exports.default = function (stringifyRules, css) {
	  var injectGlobal = function injectGlobal(strings) {
	    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    var rules = css.apply(undefined, [strings].concat(interpolations));
	    var hash = (0, _hash2.default)(JSON.stringify(rules));
	
	    var componentId = 'sc-global-' + hash;
	    if (_StyleSheet2.default.instance.hasInjectedComponent(componentId)) return;
	
	    _StyleSheet2.default.instance.inject(componentId, false, stringifyRules(rules));
	  };
	
	  return injectGlobal;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _hash = __webpack_require__(20);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _StyleSheet = __webpack_require__(7);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Stringifier = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_Stringifier || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_NameGenerator = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_NameGenerator || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(1).any;
	
	var replaceWhitespace = function replaceWhitespace(str) {
	  return str.replace(/\s|\\n/g, '');
	};
	
	exports.default = function (nameGenerator, stringifyRules, css) {
	  return function (strings) {
	    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    var rules = css.apply(undefined, [strings].concat(interpolations));
	    var hash = (0, _hash2.default)(replaceWhitespace(JSON.stringify(rules)));
	
	    var existingName = _StyleSheet2.default.instance.getName(hash);
	    if (existingName) return existingName;
	
	    var name = nameGenerator(hash);
	    if (_StyleSheet2.default.instance.alreadyInjected(hash, name)) return name;
	
	    var generatedCSS = stringifyRules(rules, name, '@keyframes');
	    _StyleSheet2.default.instance.inject('sc-keyframes-' + name, true, generatedCSS, hash, name);
	    return name;
	  };
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _domElements = __webpack_require__(121);
	
	var _domElements2 = _interopRequireDefault(_domElements);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(1).any;
	
	exports.default = function (styledComponent, constructWithOptions) {
	  var styled = function styled(tag) {
	    return constructWithOptions(styledComponent, tag);
	  };
	
	  // Shorthands for all valid HTML Elements
	  _domElements2.default.forEach(function (domElement) {
	    styled[domElement] = styled(domElement);
	  });
	
	  return styled;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(25);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ThemeProvider = __webpack_require__(12);
	
	var _isStyledComponent2 = __webpack_require__(48);
	
	var _isStyledComponent3 = _interopRequireDefault(_isStyledComponent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* globals ReactClass */
	
	var wrapWithTheme = function wrapWithTheme(Component) {
	  var _WithTheme$contextTyp;
	
	  var componentName = Component.displayName || Component.name || 'Component';
	
	  var isStyledComponent = (0, _isStyledComponent3.default)(Component);
	
	  var WithTheme = function (_React$Component) {
	    _inherits(WithTheme, _React$Component);
	
	    function WithTheme() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, WithTheme);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _this.unsubscribeId = -1, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
	
	
	    WithTheme.prototype.componentWillMount = function componentWillMount() {
	      var _this2 = this;
	
	      var styledContext = this.context[_ThemeProvider.CHANNEL_NEXT];
	      if (styledContext === undefined) {
	        // eslint-disable-next-line no-console
	        console.error('[withTheme] Please use ThemeProvider to be able to use withTheme');
	        return;
	      }
	
	      var subscribe = styledContext.subscribe;
	
	      this.unsubscribeId = subscribe(function (theme) {
	        _this2.setState({ theme: theme });
	      });
	    };
	
	    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.unsubscribeId !== -1) {
	        this.context[_ThemeProvider.CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	      }
	    };
	
	    WithTheme.prototype.render = function render() {
	      // eslint-disable-next-line react/prop-types
	      var innerRef = this.props.innerRef;
	      var theme = this.state.theme;
	
	
	      return _react2.default.createElement(Component, _extends({
	        theme: theme
	      }, this.props, {
	        innerRef: isStyledComponent ? innerRef : undefined,
	        ref: isStyledComponent ? undefined : innerRef
	      }));
	    };
	
	    return WithTheme;
	  }(_react2.default.Component);
	
	  WithTheme.displayName = 'WithTheme(' + componentName + ')';
	  WithTheme.styledComponentId = 'withTheme';
	  WithTheme.contextTypes = (_WithTheme$contextTyp = {}, _WithTheme$contextTyp[_ThemeProvider.CHANNEL] = _propTypes2.default.func, _WithTheme$contextTyp[_ThemeProvider.CHANNEL_NEXT] = _ThemeProvider.CONTEXT_CHANNEL_SHAPE, _WithTheme$contextTyp);
	
	
	  return (0, _hoistNonReactStatics2.default)(WithTheme, Component);
	};
	
	exports.default = wrapWithTheme;
	module.exports = exports['default'];

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.StyleSheetManager = exports.ServerStyleSheet = exports.withTheme = exports.ThemeProvider = exports.injectGlobal = exports.keyframes = exports.css = undefined;
	
	var _flatten = __webpack_require__(47);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _stringifyRules = __webpack_require__(128);
	
	var _stringifyRules2 = _interopRequireDefault(_stringifyRules);
	
	var _generateAlphabeticName = __webpack_require__(123);
	
	var _generateAlphabeticName2 = _interopRequireDefault(_generateAlphabeticName);
	
	var _css = __webpack_require__(112);
	
	var _css2 = _interopRequireDefault(_css);
	
	var _ServerStyleSheet = __webpack_require__(44);
	
	var _ServerStyleSheet2 = _interopRequireDefault(_ServerStyleSheet);
	
	var _StyleSheetManager = __webpack_require__(45);
	
	var _StyleSheetManager2 = _interopRequireDefault(_StyleSheetManager);
	
	var _StyledComponent2 = __webpack_require__(119);
	
	var _StyledComponent3 = _interopRequireDefault(_StyledComponent2);
	
	var _ComponentStyle2 = __webpack_require__(118);
	
	var _ComponentStyle3 = _interopRequireDefault(_ComponentStyle2);
	
	var _styled2 = __webpack_require__(115);
	
	var _styled3 = _interopRequireDefault(_styled2);
	
	var _keyframes2 = __webpack_require__(114);
	
	var _keyframes3 = _interopRequireDefault(_keyframes2);
	
	var _injectGlobal2 = __webpack_require__(113);
	
	var _injectGlobal3 = _interopRequireDefault(_injectGlobal2);
	
	var _constructWithOptions2 = __webpack_require__(111);
	
	var _constructWithOptions3 = _interopRequireDefault(_constructWithOptions2);
	
	var _ThemeProvider = __webpack_require__(12);
	
	var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);
	
	var _withTheme = __webpack_require__(116);
	
	var _withTheme2 = _interopRequireDefault(_withTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Instantiate singletons */
	
	
	/* Import components */
	
	
	/* Import singleton constructors */
	
	
	/* Import singletons */
	var ComponentStyle = (0, _ComponentStyle3.default)(_generateAlphabeticName2.default, _flatten2.default, _stringifyRules2.default);
	
	/* Import Higher Order Components */
	
	var constructWithOptions = (0, _constructWithOptions3.default)(_css2.default);
	var StyledComponent = (0, _StyledComponent3.default)(ComponentStyle, constructWithOptions);
	
	/* Instantiate exported singletons */
	var keyframes = (0, _keyframes3.default)(_generateAlphabeticName2.default, _stringifyRules2.default, _css2.default);
	var injectGlobal = (0, _injectGlobal3.default)(_stringifyRules2.default, _css2.default);
	var styled = (0, _styled3.default)(StyledComponent, constructWithOptions);
	
	/* Export everything */
	exports.default = styled;
	exports.css = _css2.default;
	exports.keyframes = keyframes;
	exports.injectGlobal = injectGlobal;
	exports.ThemeProvider = _ThemeProvider2.default;
	exports.withTheme = _withTheme2.default;
	exports.ServerStyleSheet = _ServerStyleSheet2.default;
	exports.StyleSheetManager = _StyleSheetManager2.default;

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.COMPONENTS_PER_TAG = undefined;
	
	var _extractCompsFromCSS = __webpack_require__(122);
	
	var _extractCompsFromCSS2 = _interopRequireDefault(_extractCompsFromCSS);
	
	var _nonce = __webpack_require__(49);
	
	var _nonce2 = _interopRequireDefault(_nonce);
	
	var _StyleSheet = __webpack_require__(7);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	/* eslint-disable no-underscore-dangle */
	/*
	 * Browser Style Sheet with Rehydration
	 *
	 * <style data-styled-components="x y z"
	 *        data-styled-components-is-local="true">
	 *   /· sc-component-id: a ·/
	 *   .sc-a { ... }
	 *   .x { ... }
	 *   /· sc-component-id: b ·/
	 *   .sc-b { ... }
	 *   .y { ... }
	 *   .z { ... }
	 * </style>
	 *
	 * Note: replace · with * in the above snippet.
	 * */
	
	
	var babelPluginFlowReactPropTypes_proptype_Tag = __webpack_require__(7).babelPluginFlowReactPropTypes_proptype_Tag || __webpack_require__(1).any;
	
	var COMPONENTS_PER_TAG = exports.COMPONENTS_PER_TAG = 40;
	
	var BrowserTag = function () {
	  function BrowserTag(el, isLocal) {
	    var existingSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	    _classCallCheck(this, BrowserTag);
	
	    this.el = el;
	    this.isLocal = isLocal;
	    this.ready = false;
	
	    var extractedComps = (0, _extractCompsFromCSS2.default)(existingSource);
	
	    this.size = extractedComps.length;
	    this.components = extractedComps.reduce(function (acc, obj) {
	      acc[obj.componentId] = obj; // eslint-disable-line no-param-reassign
	      return acc;
	    }, {});
	  }
	
	  BrowserTag.prototype.isFull = function isFull() {
	    return this.size >= COMPONENTS_PER_TAG;
	  };
	
	  BrowserTag.prototype.addComponent = function addComponent(componentId) {
	    if (!this.ready) this.replaceElement();
	    if (this.components[componentId]) throw new Error('Trying to add Component \'' + componentId + '\' twice!');
	
	    var comp = { componentId: componentId, textNode: document.createTextNode('') };
	    this.el.appendChild(comp.textNode);
	
	    this.size += 1;
	    this.components[componentId] = comp;
	  };
	
	  BrowserTag.prototype.inject = function inject(componentId, css, name) {
	    if (!this.ready) this.replaceElement();
	    var comp = this.components[componentId];
	
	    if (!comp) throw new Error('Must add a new component before you can inject css into it');
	    if (comp.textNode.data === '') comp.textNode.appendData('\n/* sc-component-id: ' + componentId + ' */\n');
	
	    comp.textNode.appendData(css);
	    if (name) {
	      var existingNames = this.el.getAttribute(_StyleSheet.SC_ATTR);
	      this.el.setAttribute(_StyleSheet.SC_ATTR, existingNames ? existingNames + ' ' + name : name);
	    }
	
	    var nonce = (0, _nonce2.default)();
	
	    if (nonce) {
	      this.el.setAttribute('nonce', nonce);
	    }
	  };
	
	  BrowserTag.prototype.toHTML = function toHTML() {
	    return this.el.outerHTML;
	  };
	
	  BrowserTag.prototype.toReactElement = function toReactElement() {
	    throw new Error('BrowserTag doesn\'t implement toReactElement!');
	  };
	
	  BrowserTag.prototype.clone = function clone() {
	    throw new Error('BrowserTag cannot be cloned!');
	  };
	
	  /* Because we care about source order, before we can inject anything we need to
	   * create a text node for each component and replace the existing CSS. */
	
	
	  BrowserTag.prototype.replaceElement = function replaceElement() {
	    var _this = this;
	
	    this.ready = true;
	    // We have nothing to inject. Use the current el.
	    if (this.size === 0) return;
	
	    // Build up our replacement style tag
	    var newEl = this.el.cloneNode();
	    newEl.appendChild(document.createTextNode('\n'));
	
	    Object.keys(this.components).forEach(function (key) {
	      var comp = _this.components[key];
	
	      // eslint-disable-next-line no-param-reassign
	      comp.textNode = document.createTextNode(comp.cssFromDOM);
	      newEl.appendChild(comp.textNode);
	    });
	
	    if (!this.el.parentNode) throw new Error("Trying to replace an element that wasn't mounted!");
	
	    // The ol' switcheroo
	    this.el.parentNode.replaceChild(newEl, this.el);
	    this.el = newEl;
	  };
	
	  return BrowserTag;
	}();
	
	/* Factory function to separate DOM operations from logical ones*/
	
	
	exports.default = {
	  create: function create() {
	    var tags = [];
	    var names = {};
	
	    /* Construct existing state from DOM */
	    var nodes = document.querySelectorAll('[' + _StyleSheet.SC_ATTR + ']');
	    var nodesLength = nodes.length;
	
	    for (var i = 0; i < nodesLength; i += 1) {
	      var el = nodes[i];
	
	      tags.push(new BrowserTag(el, el.getAttribute(_StyleSheet.LOCAL_ATTR) === 'true', el.innerHTML));
	
	      var attr = el.getAttribute(_StyleSheet.SC_ATTR);
	      if (attr) {
	        attr.trim().split(/\s+/).forEach(function (name) {
	          names[name] = true;
	        });
	      }
	    }
	
	    /* Factory for making more tags */
	    var tagConstructor = function tagConstructor(isLocal) {
	      var el = document.createElement('style');
	      el.type = 'text/css';
	      el.setAttribute(_StyleSheet.SC_ATTR, '');
	      el.setAttribute(_StyleSheet.LOCAL_ATTR, isLocal ? 'true' : 'false');
	      if (!document.head) throw new Error('Missing document <head>');
	      document.head.appendChild(el);
	      return new BrowserTag(el, isLocal);
	    };
	
	    return new _StyleSheet2.default(tagConstructor, tags, names);
	  }
	};

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _hash = __webpack_require__(20);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _StyleSheet = __webpack_require__(7);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var babelPluginFlowReactPropTypes_proptype_Stringifier = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_Stringifier || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_Flattener = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_Flattener || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_NameGenerator = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_NameGenerator || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_RuleSet = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_RuleSet || __webpack_require__(1).any;
	
	/*
	 ComponentStyle is all the CSS-specific stuff, not
	 the React-specific stuff.
	 */
	exports.default = function (nameGenerator, flatten, stringifyRules) {
	  var ComponentStyle = function () {
	    function ComponentStyle(rules, componentId) {
	      _classCallCheck(this, ComponentStyle);
	
	      this.rules = rules;
	      this.componentId = componentId;
	      if (!_StyleSheet2.default.instance.hasInjectedComponent(this.componentId)) {
	        var placeholder =  false ? '.' + componentId + ' {}' : '';
	        _StyleSheet2.default.instance.deferredInject(componentId, true, placeholder);
	      }
	    }
	
	    /*
	     * Flattens a rule set into valid CSS
	     * Hashes it, wraps the whole chunk in a .hash1234 {}
	     * Returns the hash to be injected on render()
	     * */
	
	
	    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
	      var flatCSS = flatten(this.rules, executionContext);
	      var hash = (0, _hash2.default)(this.componentId + flatCSS.join(''));
	
	      var existingName = styleSheet.getName(hash);
	      if (existingName) return existingName;
	
	      var name = nameGenerator(hash);
	      if (styleSheet.alreadyInjected(hash, name)) return name;
	
	      var css = '\n' + stringifyRules(flatCSS, '.' + name);
	      styleSheet.inject(this.componentId, true, css, hash, name);
	      return name;
	    };
	
	    ComponentStyle.generateName = function generateName(str) {
	      return nameGenerator((0, _hash2.default)(str));
	    };
	
	    return ComponentStyle;
	  }();
	
	  return ComponentStyle;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(7);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _StyleSheetManager = __webpack_require__(45);
	
	var _StyleSheetManager2 = _interopRequireDefault(_StyleSheetManager);
	
	var _nonce = __webpack_require__(49);
	
	var _nonce2 = _interopRequireDefault(_nonce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	/* eslint-disable no-underscore-dangle */
	
	
	var babelPluginFlowReactPropTypes_proptype_Tag = __webpack_require__(7).babelPluginFlowReactPropTypes_proptype_Tag || __webpack_require__(1).any;
	
	var ServerTag = function () {
	  function ServerTag(isLocal) {
	    _classCallCheck(this, ServerTag);
	
	    this.isLocal = isLocal;
	    this.components = {};
	    this.size = 0;
	    this.names = [];
	  }
	
	  ServerTag.prototype.isFull = function isFull() {
	    return false;
	  };
	
	  ServerTag.prototype.addComponent = function addComponent(componentId) {
	    if (this.components[componentId]) throw new Error('Trying to add Component \'' + componentId + '\' twice!');
	    this.components[componentId] = { componentId: componentId, css: '' };
	    this.size += 1;
	  };
	
	  ServerTag.prototype.concatenateCSS = function concatenateCSS() {
	    var _this = this;
	
	    return Object.keys(this.components).reduce(function (styles, k) {
	      return styles + _this.components[k].css;
	    }, '');
	  };
	
	  ServerTag.prototype.inject = function inject(componentId, css, name) {
	    var comp = this.components[componentId];
	
	    if (!comp) throw new Error('Must add a new component before you can inject css into it');
	    if (comp.css === '') comp.css = '/* sc-component-id: ' + componentId + ' */\n';
	
	    comp.css += css.replace(/\n*$/, '\n');
	
	    if (name) this.names.push(name);
	  };
	
	  ServerTag.prototype.toHTML = function toHTML() {
	    var attrs = ['type="text/css"', _StyleSheet.SC_ATTR + '="' + this.names.join(' ') + '"', _StyleSheet.LOCAL_ATTR + '="' + (this.isLocal ? 'true' : 'false') + '"'];
	
	    var nonce = (0, _nonce2.default)();
	
	    if (nonce) {
	      attrs.push('nonce="' + nonce + '"');
	    }
	
	    return '<style ' + attrs.join(' ') + '>' + this.concatenateCSS() + '</style>';
	  };
	
	  ServerTag.prototype.toReactElement = function toReactElement(key) {
	    var _attrs;
	
	    var attrs = (_attrs = {}, _attrs[_StyleSheet.SC_ATTR] = this.names.join(' '), _attrs[_StyleSheet.LOCAL_ATTR] = this.isLocal.toString(), _attrs);
	
	    var nonce = (0, _nonce2.default)();
	
	    if (nonce) {
	      attrs.nonce = nonce;
	    }
	
	    return _react2.default.createElement('style', _extends({
	      key: key, type: 'text/css' }, attrs, {
	      dangerouslySetInnerHTML: { __html: this.concatenateCSS() }
	    }));
	  };
	
	  ServerTag.prototype.clone = function clone() {
	    var _this2 = this;
	
	    var copy = new ServerTag(this.isLocal);
	    copy.names = [].concat(this.names);
	    copy.size = this.size;
	    copy.components = Object.keys(this.components).reduce(function (acc, key) {
	      acc[key] = _extends({}, _this2.components[key]); // eslint-disable-line no-param-reassign
	      return acc;
	    }, {});
	
	    return copy;
	  };
	
	  return ServerTag;
	}();
	
	var ServerStyleSheet = function () {
	  function ServerStyleSheet() {
	    _classCallCheck(this, ServerStyleSheet);
	
	    this.instance = _StyleSheet2.default.clone(_StyleSheet2.default.instance);
	  }
	
	  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
	    if (this.closed) throw new Error("Can't collect styles once you've called getStyleTags!");
	    return _react2.default.createElement(
	      _StyleSheetManager2.default,
	      { sheet: this.instance },
	      children
	    );
	  };
	
	  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
	    if (!this.closed) {
	      _StyleSheet.clones.splice(_StyleSheet.clones.indexOf(this.instance), 1);
	      this.closed = true;
	    }
	
	    return this.instance.toHTML();
	  };
	
	  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
	    if (!this.closed) {
	      _StyleSheet.clones.splice(_StyleSheet.clones.indexOf(this.instance), 1);
	      this.closed = true;
	    }
	
	    return this.instance.toReactElements();
	  };
	
	  ServerStyleSheet.create = function create() {
	    return new _StyleSheet2.default(function (isLocal) {
	      return new ServerTag(isLocal);
	    });
	  };
	
	  return ServerStyleSheet;
	}();
	
	exports.default = ServerStyleSheet;
	module.exports = exports['default'];

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.clones = exports.CONTEXT_KEY = exports.LOCAL_ATTR = exports.SC_ATTR = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BrowserStyleSheet = __webpack_require__(117);
	
	var _BrowserStyleSheet2 = _interopRequireDefault(_BrowserStyleSheet);
	
	var _ServerStyleSheet = __webpack_require__(44);
	
	var _ServerStyleSheet2 = _interopRequireDefault(_ServerStyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SC_ATTR = exports.SC_ATTR = 'data-styled-components';
	var LOCAL_ATTR = exports.LOCAL_ATTR = 'data-styled-components-is-local';
	var CONTEXT_KEY = exports.CONTEXT_KEY = '__styled-components-stylesheet__';
	
	var instance = null;
	// eslint-disable-next-line no-use-before-define
	var clones = exports.clones = [];
	
	var StyleSheet = function () {
	  function StyleSheet(tagConstructor) {
	    var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var names = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    _classCallCheck(this, StyleSheet);
	
	    this.hashes = {};
	    this.deferredInjections = {};
	
	    this.tagConstructor = tagConstructor;
	    this.tags = tags;
	    this.names = names;
	    this.constructComponentTagMap();
	  }
	
	  StyleSheet.prototype.constructComponentTagMap = function constructComponentTagMap() {
	    var _this = this;
	
	    this.componentTags = {};
	
	    this.tags.forEach(function (tag) {
	      Object.keys(tag.components).forEach(function (componentId) {
	        _this.componentTags[componentId] = tag;
	      });
	    });
	  };
	
	  /* Best level of caching—get the name from the hash straight away. */
	
	
	  StyleSheet.prototype.getName = function getName(hash) {
	    return this.hashes[hash.toString()];
	  };
	
	  /* Second level of caching—if the name is already in the dom, don't
	   * inject anything and record the hash for getName next time. */
	
	
	  StyleSheet.prototype.alreadyInjected = function alreadyInjected(hash, name) {
	    if (!this.names[name]) return false;
	
	    this.hashes[hash.toString()] = name;
	    return true;
	  };
	
	  /* Third type of caching—don't inject components' componentId twice. */
	
	
	  StyleSheet.prototype.hasInjectedComponent = function hasInjectedComponent(componentId) {
	    return !!this.componentTags[componentId];
	  };
	
	  StyleSheet.prototype.deferredInject = function deferredInject(componentId, isLocal, css) {
	    if (this === instance) {
	      clones.forEach(function (clone) {
	        clone.deferredInject(componentId, isLocal, css);
	      });
	    }
	
	    this.getOrCreateTag(componentId, isLocal);
	    this.deferredInjections[componentId] = css;
	  };
	
	  StyleSheet.prototype.inject = function inject(componentId, isLocal, css, hash, name) {
	    if (this === instance) {
	      clones.forEach(function (clone) {
	        clone.inject(componentId, isLocal, css);
	      });
	    }
	
	    var tag = this.getOrCreateTag(componentId, isLocal);
	
	    var deferredInjection = this.deferredInjections[componentId];
	    if (deferredInjection) {
	      tag.inject(componentId, deferredInjection);
	      delete this.deferredInjections[componentId];
	    }
	
	    tag.inject(componentId, css, name);
	
	    if (hash && name) {
	      this.hashes[hash.toString()] = name;
	    }
	  };
	
	  StyleSheet.prototype.toHTML = function toHTML() {
	    return this.tags.map(function (tag) {
	      return tag.toHTML();
	    }).join('');
	  };
	
	  StyleSheet.prototype.toReactElements = function toReactElements() {
	    return this.tags.map(function (tag, i) {
	      return tag.toReactElement('sc-' + i);
	    });
	  };
	
	  StyleSheet.prototype.getOrCreateTag = function getOrCreateTag(componentId, isLocal) {
	    var existingTag = this.componentTags[componentId];
	    if (existingTag) {
	      return existingTag;
	    }
	
	    var lastTag = this.tags[this.tags.length - 1];
	    var componentTag = !lastTag || lastTag.isFull() || lastTag.isLocal !== isLocal ? this.createNewTag(isLocal) : lastTag;
	    this.componentTags[componentId] = componentTag;
	    componentTag.addComponent(componentId);
	    return componentTag;
	  };
	
	  StyleSheet.prototype.createNewTag = function createNewTag(isLocal) {
	    var newTag = this.tagConstructor(isLocal);
	    this.tags.push(newTag);
	    return newTag;
	  };
	
	  StyleSheet.reset = function reset(isServer) {
	    instance = StyleSheet.create(isServer);
	  };
	
	  /* We can make isServer totally implicit once Jest 20 drops and we
	   * can change environment on a per-test basis. */
	
	
	  StyleSheet.create = function create() {
	    var isServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typeof document === 'undefined';
	
	    return (isServer ? _ServerStyleSheet2.default : _BrowserStyleSheet2.default).create();
	  };
	
	  StyleSheet.clone = function clone(oldSheet) {
	    var newSheet = new StyleSheet(oldSheet.tagConstructor, oldSheet.tags.map(function (tag) {
	      return tag.clone();
	    }), _extends({}, oldSheet.names));
	
	    newSheet.hashes = _extends({}, oldSheet.hashes);
	    newSheet.deferredInjections = _extends({}, oldSheet.deferredInjections);
	    clones.push(newSheet);
	
	    return newSheet;
	  };
	
	  _createClass(StyleSheet, null, [{
	    key: 'instance',
	    get: function get() {
	      return instance || (instance = StyleSheet.create());
	    }
	  }]);
	
	  return StyleSheet;
	}();
	
	exports.default = StyleSheet;

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StyleSheetManager$ch;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleSheet = __webpack_require__(7);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StyleSheetManager = function (_Component) {
	  _inherits(StyleSheetManager, _Component);
	
	  function StyleSheetManager() {
	    _classCallCheck(this, StyleSheetManager);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  StyleSheetManager.prototype.getChildContext = function getChildContext() {
	    var _ref;
	
	    return _ref = {}, _ref[_StyleSheet.CONTEXT_KEY] = this.props.sheet, _ref;
	  };
	
	  StyleSheetManager.prototype.render = function render() {
	    /* eslint-disable react/prop-types */
	    // Flow v0.43.1 will report an error accessing the `children` property,
	    // but v0.47.0 will not. It is necessary to use a type cast instead of
	    // a "fixme" comment to satisfy both Flow versions.
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return StyleSheetManager;
	}(_react.Component);
	
	StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[_StyleSheet.CONTEXT_KEY] = _propTypes2.default.instanceOf(_StyleSheet2.default).isRequired, _StyleSheetManager$ch);
	
	StyleSheetManager.propTypes = {
	  sheet: _propTypes2.default.instanceOf(_StyleSheet2.default).isRequired
	};
	
	exports.default = StyleSheetManager;
	module.exports = exports['default'];

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createWarnTooManyClasses = __webpack_require__(120);
	
	var _createWarnTooManyClasses2 = _interopRequireDefault(_createWarnTooManyClasses);
	
	var _validAttr = __webpack_require__(129);
	
	var _validAttr2 = _interopRequireDefault(_validAttr);
	
	var _isTag = __webpack_require__(126);
	
	var _isTag2 = _interopRequireDefault(_isTag);
	
	var _isStyledComponent = __webpack_require__(48);
	
	var _isStyledComponent2 = _interopRequireDefault(_isStyledComponent);
	
	var _getComponentName = __webpack_require__(124);
	
	var _getComponentName2 = _interopRequireDefault(_getComponentName);
	
	var _ThemeProvider = __webpack_require__(12);
	
	var _StyleSheet = __webpack_require__(7);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var babelPluginFlowReactPropTypes_proptype_Theme = __webpack_require__(12).babelPluginFlowReactPropTypes_proptype_Theme || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_RuleSet = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_RuleSet || __webpack_require__(1).any;
	
	var escapeRegex = /[[\].#*$><+~=|^:(),"'`]/g;
	var multiDashRegex = /--+/g;
	
	exports.default = function (ComponentStyle, constructWithOptions) {
	  /* We depend on components having unique IDs */
	  var identifiers = {};
	  var generateId = function generateId(_displayName, parentComponentId) {
	    var displayName = typeof _displayName !== 'string' ? 'sc' : _displayName.replace(escapeRegex, '-') // Replace all possible CSS selectors
	    .replace(multiDashRegex, '-'); // Replace multiple -- with single -
	
	    var nr = (identifiers[displayName] || 0) + 1;
	    identifiers[displayName] = nr;
	
	    var hash = ComponentStyle.generateName(displayName + nr);
	    var componentId = displayName + '-' + hash;
	    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
	  };
	
	  var BaseStyledComponent = function (_Component) {
	    _inherits(BaseStyledComponent, _Component);
	
	    function BaseStyledComponent() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, BaseStyledComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
	        theme: null,
	        generatedClassName: ''
	      }, _this.unsubscribeId = -1, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
	      if (this.unsubscribeId !== -1) {
	        this.context[_ThemeProvider.CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	      }
	    };
	
	    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
	      var attrs = this.constructor.attrs;
	
	      var context = _extends({}, props, { theme: theme });
	      if (attrs === undefined) {
	        return context;
	      }
	
	      this.attrs = Object.keys(attrs).reduce(function (acc, key) {
	        var attr = attrs[key];
	        // eslint-disable-next-line no-param-reassign
	        acc[key] = typeof attr === 'function' ? attr(context) : attr;
	        return acc;
	      }, {});
	
	      return _extends({}, context, this.attrs);
	    };
	
	    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
	      var _constructor = this.constructor,
	          componentStyle = _constructor.componentStyle,
	          warnTooManyClasses = _constructor.warnTooManyClasses;
	
	      var executionContext = this.buildExecutionContext(theme, props);
	      var styleSheet = this.context[_StyleSheet.CONTEXT_KEY] || _StyleSheet2.default.instance;
	      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
	
	      if (warnTooManyClasses !== undefined) warnTooManyClasses(className);
	
	      return className;
	    };
	
	    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
	      var _this2 = this;
	
	      // If there is a theme in the context, subscribe to the event emitter. This
	      // is necessary due to pure components blocking context updates, this circumvents
	      // that by updating when an event is emitted
	      var styledContext = this.context[_ThemeProvider.CHANNEL_NEXT];
	      if (styledContext !== undefined) {
	        var subscribe = styledContext.subscribe;
	
	        this.unsubscribeId = subscribe(function (nextTheme) {
	          // This will be called once immediately
	
	          // Props should take precedence over ThemeProvider, which should take precedence over
	          // defaultProps, but React automatically puts defaultProps on props.
	          var defaultProps = _this2.constructor.defaultProps;
	          /* eslint-disable react/prop-types */
	
	          var isDefaultTheme = defaultProps && _this2.props.theme === defaultProps.theme;
	          var theme = _this2.props.theme && !isDefaultTheme ? _this2.props.theme : nextTheme;
	          /* eslint-enable */
	          var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
	          _this2.setState({ theme: theme, generatedClassName: generatedClassName });
	        });
	      } else {
	        // eslint-disable-next-line react/prop-types
	        var _theme = this.props.theme || {};
	        var generatedClassName = this.generateAndInjectStyles(_theme, this.props);
	        this.setState({ theme: _theme, generatedClassName: generatedClassName });
	      }
	    };
	
	    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      this.setState(function (oldState) {
	        // Props should take precedence over ThemeProvider, which should take precedence over
	        // defaultProps, but React automatically puts defaultProps on props.
	        var defaultProps = _this3.constructor.defaultProps;
	        /* eslint-disable react/prop-types */
	
	        var isDefaultTheme = defaultProps && nextProps.theme === defaultProps.theme;
	        var theme = nextProps.theme && !isDefaultTheme ? nextProps.theme : oldState.theme;
	        /* eslint-enable */
	        var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
	
	        return { theme: theme, generatedClassName: generatedClassName };
	      });
	    };
	
	    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	      this.unsubscribeFromContext();
	    };
	
	    BaseStyledComponent.prototype.render = function render() {
	      var _this4 = this;
	
	      // eslint-disable-next-line react/prop-types
	      var innerRef = this.props.innerRef;
	      var generatedClassName = this.state.generatedClassName;
	      var _constructor2 = this.constructor,
	          styledComponentId = _constructor2.styledComponentId,
	          target = _constructor2.target;
	
	
	      var isTargetTag = (0, _isTag2.default)(target);
	
	      var className = [
	      // eslint-disable-next-line react/prop-types
	      this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');
	
	      var baseProps = _extends({}, this.attrs, {
	        className: className
	      });
	
	      if ((0, _isStyledComponent2.default)(target)) {
	        baseProps.innerRef = innerRef;
	      } else {
	        baseProps.ref = innerRef;
	      }
	
	      var propsForElement = Object.keys(this.props).reduce(function (acc, propName) {
	        // Don't pass through non HTML tags through to HTML elements
	        // always omit innerRef
	        if (propName !== 'innerRef' && propName !== 'className' && (!isTargetTag || (0, _validAttr2.default)(propName))) {
	          // eslint-disable-next-line no-param-reassign
	          acc[propName] = _this4.props[propName];
	        }
	
	        return acc;
	      }, baseProps);
	
	      return (0, _react.createElement)(target, propsForElement);
	    };
	
	    return BaseStyledComponent;
	  }(_react.Component);
	
	  var createStyledComponent = function createStyledComponent(target, options, rules) {
	    var _StyledComponent$cont;
	
	    var _options$displayName = options.displayName,
	        displayName = _options$displayName === undefined ? (0, _isTag2.default)(target) ? 'styled.' + target : 'Styled(' + (0, _getComponentName2.default)(target) + ')' : _options$displayName,
	        _options$componentId = options.componentId,
	        componentId = _options$componentId === undefined ? generateId(options.displayName, options.parentComponentId) : _options$componentId,
	        _options$ParentCompon = options.ParentComponent,
	        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
	        extendingRules = options.rules,
	        attrs = options.attrs;
	
	
	    var styledComponentId = options.displayName && options.componentId ? options.displayName + '-' + options.componentId : componentId;
	
	    var warnTooManyClasses = void 0;
	    if (false) {
	      warnTooManyClasses = (0, _createWarnTooManyClasses2.default)(displayName);
	    }
	
	    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), styledComponentId);
	
	    var StyledComponent = function (_ParentComponent) {
	      _inherits(StyledComponent, _ParentComponent);
	
	      function StyledComponent() {
	        _classCallCheck(this, StyledComponent);
	
	        return _possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
	      }
	
	      StyledComponent.withComponent = function withComponent(tag) {
	        var previousComponentId = options.componentId,
	            optionsToCopy = _objectWithoutProperties(options, ['componentId']);
	
	        var newComponentId = previousComponentId && previousComponentId + '-' + ((0, _isTag2.default)(tag) ? tag : (0, _getComponentName2.default)(tag));
	
	        var newOptions = _extends({}, optionsToCopy, {
	          componentId: newComponentId,
	          ParentComponent: StyledComponent
	        });
	
	        return createStyledComponent(tag, newOptions, rules);
	      };
	
	      _createClass(StyledComponent, null, [{
	        key: 'extend',
	        get: function get() {
	          var rulesFromOptions = options.rules,
	              parentComponentId = options.componentId,
	              optionsToCopy = _objectWithoutProperties(options, ['rules', 'componentId']);
	
	          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
	
	          var newOptions = _extends({}, optionsToCopy, {
	            rules: newRules,
	            parentComponentId: parentComponentId,
	            ParentComponent: StyledComponent
	          });
	
	          return constructWithOptions(createStyledComponent, target, newOptions);
	        }
	      }]);
	
	      return StyledComponent;
	    }(ParentComponent);
	
	    StyledComponent.contextTypes = (_StyledComponent$cont = {}, _StyledComponent$cont[_ThemeProvider.CHANNEL] = _propTypes2.default.func, _StyledComponent$cont[_ThemeProvider.CHANNEL_NEXT] = _ThemeProvider.CONTEXT_CHANNEL_SHAPE, _StyledComponent$cont[_StyleSheet.CONTEXT_KEY] = _propTypes2.default.instanceOf(_StyleSheet2.default), _StyledComponent$cont);
	    StyledComponent.displayName = displayName;
	    StyledComponent.styledComponentId = styledComponentId;
	    StyledComponent.attrs = attrs;
	    StyledComponent.componentStyle = componentStyle;
	    StyledComponent.warnTooManyClasses = warnTooManyClasses;
	    StyledComponent.target = target;
	
	
	    return StyledComponent;
	  };
	
	  return createStyledComponent;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CONTEXT_CHANNEL_SHAPE = exports.CHANNEL_NEXT = exports.CHANNEL = undefined;
	
	var _ThemeProvider$childC, _ThemeProvider$contex;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isFunction = __webpack_require__(80);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isPlainObject = __webpack_require__(34);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _createBroadcast = __webpack_require__(46);
	
	var _createBroadcast2 = _interopRequireDefault(_createBroadcast);
	
	var _once = __webpack_require__(127);
	
	var _once2 = _interopRequireDefault(_once);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* globals React$Element */
	
	
	var babelPluginFlowReactPropTypes_proptype_Broadcast = __webpack_require__(46).babelPluginFlowReactPropTypes_proptype_Broadcast || __webpack_require__(1).any;
	
	// NOTE: DO NOT CHANGE, changing this is a semver major change!
	var CHANNEL = exports.CHANNEL = '__styled-components__';
	var CHANNEL_NEXT = exports.CHANNEL_NEXT = CHANNEL + 'next__';
	
	var CONTEXT_CHANNEL_SHAPE = exports.CONTEXT_CHANNEL_SHAPE = _propTypes2.default.shape({
	  getTheme: _propTypes2.default.func,
	  subscribe: _propTypes2.default.func,
	  unsubscribe: _propTypes2.default.func
	});
	
	if (true) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Theme', {
	  value: __webpack_require__(1).shape({})
	});
	
	
	var warnChannelDeprecated = (0, _once2.default)(function () {
	  // eslint-disable-next-line no-console
	  console.error('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
	});
	/**
	 * Provide a theme to an entire react component tree via context and event listeners (have to do
	 * both context and event emitter as pure components block context updates)
	 */
	
	var ThemeProvider = function (_Component) {
	  _inherits(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    _classCallCheck(this, ThemeProvider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.unsubscribeToOuterId = -1;
	
	    _this.getTheme = _this.getTheme.bind(_this);
	    return _this;
	  }
	
	  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
	    // with the outer theme
	    var outerContext = this.context[CHANNEL_NEXT];
	    if (outerContext !== undefined) {
	      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
	        _this2.outerTheme = theme;
	      });
	    }
	    this.broadcast = (0, _createBroadcast2.default)(this.getTheme());
	  };
	
	  ThemeProvider.prototype.getChildContext = function getChildContext() {
	    var _this3 = this,
	        _extends2;
	
	    return _extends({}, this.context, (_extends2 = {}, _extends2[CHANNEL_NEXT] = {
	      getTheme: this.getTheme,
	      subscribe: this.broadcast.subscribe,
	      unsubscribe: this.broadcast.unsubscribe
	    }, _extends2[CHANNEL] = function (subscriber) {
	      warnChannelDeprecated();
	
	      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
	      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
	      return function () {
	        return _this3.broadcast.unsubscribe(unsubscribeId);
	      };
	    }, _extends2));
	  };
	
	  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.theme !== nextProps.theme) this.broadcast.publish(this.getTheme(nextProps.theme));
	  };
	
	  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeToOuterId !== -1) {
	      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
	    }
	  };
	
	  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	
	
	  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
	    var theme = passedTheme || this.props.theme;
	    if ((0, _isFunction2.default)(theme)) {
	      var mergedTheme = theme(this.outerTheme);
	      if (!(0, _isPlainObject2.default)(mergedTheme)) {
	        throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
	      }
	      return mergedTheme;
	    }
	    if (!(0, _isPlainObject2.default)(theme)) {
	      throw new Error('[ThemeProvider] Please make your theme prop a plain object');
	    }
	    return _extends({}, this.outerTheme, theme);
	  };
	
	  ThemeProvider.prototype.render = function render() {
	    if (!this.props.children) {
	      return null;
	    }
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return ThemeProvider;
	}(_react.Component);
	
	ThemeProvider.propTypes = {
	  children: __webpack_require__(1).any,
	  theme: __webpack_require__(1).oneOfType([__webpack_require__(1).shape({}), __webpack_require__(1).func]).isRequired
	};
	
	
	ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = _propTypes2.default.func, _ThemeProvider$childC[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$childC);
	ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);
	
	exports.default = ThemeProvider;

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/* todo: I want this to actually be an array of Function | string but that causes errors */
	if (true) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_StyleSheet", {
	  value: __webpack_require__(1).shape({
	    create: __webpack_require__(1).func.isRequired
	  })
	});
	
	/* eslint-disable no-undef */

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	if (true) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_Broadcast", {
	  value: __webpack_require__(1).shape({
	    publish: __webpack_require__(1).func.isRequired,
	    subscribe: __webpack_require__(1).func.isRequired,
	    unsubscribe: __webpack_require__(1).func.isRequired
	  })
	});
	/**
	 * Creates a broadcast that can be listened to, i.e. simple event emitter
	 *
	 * @see https://github.com/ReactTraining/react-broadcast
	 */
	
	var createBroadcast = function createBroadcast(initialState) {
	  var listeners = {};
	  var id = 0;
	  var state = initialState;
	
	  function publish(nextState) {
	    state = nextState;
	
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in listeners) {
	      var _listener = listeners[key];
	      if (_listener === undefined) {
	        // eslint-disable-next-line no-continue
	        continue;
	      }
	
	      _listener(state);
	    }
	  }
	
	  function subscribe(listener) {
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    listener(state);
	    return currentId;
	  }
	
	  function unsubscribe(unsubID) {
	    listeners[unsubID] = undefined;
	  }
	
	  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
	};
	
	exports.default = createBroadcast;
	module.exports = exports["default"];

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var LIMIT = 200;
	
	exports.default = function (displayName) {
	  var generatedClasses = {};
	  var warningSeen = false;
	
	  return function (className) {
	    if (!warningSeen) {
	      generatedClasses[className] = true;
	      if (Object.keys(generatedClasses).length >= LIMIT) {
	        // Unable to find latestRule in test environment.
	        /* eslint-disable no-console, prefer-template */
	        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. ' + 'Consider using style property for frequently changed styles.\n' + 'Example:\n' + '  const StyledComp = styled.div`width: 100%;`\n' + '  <StyledComp style={{ background: background }} />');
	        warningSeen = true;
	        generatedClasses = {};
	      }
	    }
	  };
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	// Thanks to ReactDOMFactories for this handy list!
	
	exports.default = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
	
	// SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	module.exports = exports['default'];

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s+(\S+)\s+\*\//mg;
	
	exports.default = function (maybeCSS) {
	  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
	  var existingComponents = [];
	  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
	    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
	    return match;
	  });
	  return existingComponents.map(function (_ref, i) {
	    var componentId = _ref.componentId,
	        matchIndex = _ref.matchIndex;
	
	    var nextComp = existingComponents[i + 1];
	    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
	    return { componentId: componentId, cssFromDOM: cssFromDOM };
	  });
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.objToCss = undefined;
	
	var _hyphenateStyleName = __webpack_require__(143);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _isPlainObject = __webpack_require__(34);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(1).any;
	
	var objToCss = exports.objToCss = function objToCss(obj, prevKey) {
	  var css = Object.keys(obj).map(function (key) {
	    if ((0, _isPlainObject2.default)(obj[key])) return objToCss(obj[key], key);
	    return (0, _hyphenateStyleName2.default)(key) + ': ' + obj[key] + ';';
	  }).join(' ');
	  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
	};
	
	var flatten = function flatten(chunks, executionContext) {
	  return chunks.reduce(function (ruleSet, chunk) {
	    /* Remove falsey values */
	    if (chunk === undefined || chunk === null || chunk === false || chunk === '') return ruleSet;
	    /* Flatten ruleSet */
	    if (Array.isArray(chunk)) return [].concat(ruleSet, flatten(chunk, executionContext));
	
	    /* Handle other components */
	    // $FlowFixMe not sure how to make this pass
	    if (chunk.hasOwnProperty('styledComponentId')) return [].concat(ruleSet, ['.' + chunk.styledComponentId]);
	
	    /* Either execute or defer the function */
	    if (typeof chunk === 'function') {
	      return executionContext ? ruleSet.concat.apply(ruleSet, flatten([chunk(executionContext)], executionContext)) : ruleSet.concat(chunk);
	    }
	
	    /* Handle objects */
	    // $FlowFixMe have to add %checks somehow to isPlainObject
	    return ruleSet.concat((0, _isPlainObject2.default)(chunk) ? objToCss(chunk) : chunk.toString());
	  }, []);
	};
	
	exports.default = flatten;

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
	var charsLength = chars.length;
	
	/* Some high number, usually 9-digit base-10. Map it to base-😎 */
	var generateAlphabeticName = function generateAlphabeticName(code) {
	  var name = '';
	  var x = void 0;
	
	  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
	    name = chars[x % charsLength] + name;
	  }
	
	  return chars[x % charsLength] + name;
	};
	
	exports.default = generateAlphabeticName;
	module.exports = exports['default'];

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getComponentName;
	
	
	/* eslint-disable no-undef */
	function getComponentName(target) {
	  return target.displayName || target.name || 'Component';
	}
	module.exports = exports['default'];

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(1).any;
	
	exports.default = function (strings, interpolations) {
	  return interpolations.reduce(function (array, interp, i) {
	    return array.concat(interp, strings[i + 1]);
	  }, [strings[0]]);
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isStyledComponent;
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(1).any;
	
	function isStyledComponent(target) /* : %checks */{
	  return typeof target === 'function' && typeof target.styledComponentId === 'string';
	}
	module.exports = exports['default'];

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isTag;
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(1).any;
	
	function isTag(target) /* : %checks */{
	  return typeof target === 'string';
	}
	module.exports = exports['default'];

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
	};
	/* eslint-disable camelcase, no-undef */
	
	module.exports = exports['default'];

/***/ }),

/***/ 127:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	// Helper to call a given function, only once
	exports.default = function (cb) {
	  var called = false;
	
	  return function () {
	    if (!called) {
	      called = true;
	      cb();
	    }
	  };
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _stylis = __webpack_require__(130);
	
	var _stylis2 = _interopRequireDefault(_stylis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(3).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(1).any;
	
	var stylis = new _stylis2.default({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: true,
	  compress: false,
	  semicolon: true
	});
	
	var stringifyRules = function stringifyRules(rules, selector, prefix) {
	  var flatCSS = rules.join('').replace(/^\s*\/\/.*$/gm, ''); // replace JS comments
	
	  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
	
	  return stylis(prefix || !selector ? '' : selector, cssStr);
	};
	
	exports.default = stringifyRules;
	module.exports = exports['default'];

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	/* Trying to avoid the unknown-prop errors on styled components
	 by filtering by React's attribute whitelist.
	 */
	
	/* Logic copied from ReactDOMUnknownPropertyHook */
	var reactProps = {
	  children: true,
	  dangerouslySetInnerHTML: true,
	  key: true,
	  ref: true,
	  autoFocus: true,
	  defaultValue: true,
	  valueLink: true,
	  defaultChecked: true,
	  checkedLink: true,
	  innerHTML: true,
	  suppressContentEditableWarning: true,
	  onFocusIn: true,
	  onFocusOut: true,
	  className: true,
	
	  /* List copied from https://facebook.github.io/react/docs/events.html */
	  onCopy: true,
	  onCut: true,
	  onPaste: true,
	  onCompositionEnd: true,
	  onCompositionStart: true,
	  onCompositionUpdate: true,
	  onKeyDown: true,
	  onKeyPress: true,
	  onKeyUp: true,
	  onFocus: true,
	  onBlur: true,
	  onChange: true,
	  onInput: true,
	  onSubmit: true,
	  onClick: true,
	  onContextMenu: true,
	  onDoubleClick: true,
	  onDrag: true,
	  onDragEnd: true,
	  onDragEnter: true,
	  onDragExit: true,
	  onDragLeave: true,
	  onDragOver: true,
	  onDragStart: true,
	  onDrop: true,
	  onMouseDown: true,
	  onMouseEnter: true,
	  onMouseLeave: true,
	  onMouseMove: true,
	  onMouseOut: true,
	  onMouseOver: true,
	  onMouseUp: true,
	  onSelect: true,
	  onTouchCancel: true,
	  onTouchEnd: true,
	  onTouchMove: true,
	  onTouchStart: true,
	  onScroll: true,
	  onWheel: true,
	  onAbort: true,
	  onCanPlay: true,
	  onCanPlayThrough: true,
	  onDurationChange: true,
	  onEmptied: true,
	  onEncrypted: true,
	  onEnded: true,
	  onError: true,
	  onLoadedData: true,
	  onLoadedMetadata: true,
	  onLoadStart: true,
	  onPause: true,
	  onPlay: true,
	  onPlaying: true,
	  onProgress: true,
	  onRateChange: true,
	  onSeeked: true,
	  onSeeking: true,
	  onStalled: true,
	  onSuspend: true,
	  onTimeUpdate: true,
	  onVolumeChange: true,
	  onWaiting: true,
	  onLoad: true,
	  onAnimationStart: true,
	  onAnimationEnd: true,
	  onAnimationIteration: true,
	  onTransitionEnd: true,
	
	  onCopyCapture: true,
	  onCutCapture: true,
	  onPasteCapture: true,
	  onCompositionEndCapture: true,
	  onCompositionStartCapture: true,
	  onCompositionUpdateCapture: true,
	  onKeyDownCapture: true,
	  onKeyPressCapture: true,
	  onKeyUpCapture: true,
	  onFocusCapture: true,
	  onBlurCapture: true,
	  onChangeCapture: true,
	  onInputCapture: true,
	  onSubmitCapture: true,
	  onClickCapture: true,
	  onContextMenuCapture: true,
	  onDoubleClickCapture: true,
	  onDragCapture: true,
	  onDragEndCapture: true,
	  onDragEnterCapture: true,
	  onDragExitCapture: true,
	  onDragLeaveCapture: true,
	  onDragOverCapture: true,
	  onDragStartCapture: true,
	  onDropCapture: true,
	  onMouseDownCapture: true,
	  onMouseEnterCapture: true,
	  onMouseLeaveCapture: true,
	  onMouseMoveCapture: true,
	  onMouseOutCapture: true,
	  onMouseOverCapture: true,
	  onMouseUpCapture: true,
	  onSelectCapture: true,
	  onTouchCancelCapture: true,
	  onTouchEndCapture: true,
	  onTouchMoveCapture: true,
	  onTouchStartCapture: true,
	  onScrollCapture: true,
	  onWheelCapture: true,
	  onAbortCapture: true,
	  onCanPlayCapture: true,
	  onCanPlayThroughCapture: true,
	  onDurationChangeCapture: true,
	  onEmptiedCapture: true,
	  onEncryptedCapture: true,
	  onEndedCapture: true,
	  onErrorCapture: true,
	  onLoadedDataCapture: true,
	  onLoadedMetadataCapture: true,
	  onLoadStartCapture: true,
	  onPauseCapture: true,
	  onPlayCapture: true,
	  onPlayingCapture: true,
	  onProgressCapture: true,
	  onRateChangeCapture: true,
	  onSeekedCapture: true,
	  onSeekingCapture: true,
	  onStalledCapture: true,
	  onSuspendCapture: true,
	  onTimeUpdateCapture: true,
	  onVolumeChangeCapture: true,
	  onWaitingCapture: true,
	  onLoadCapture: true,
	  onAnimationStartCapture: true,
	  onAnimationEndCapture: true,
	  onAnimationIterationCapture: true,
	  onTransitionEndCapture: true
	};
	
	/* From HTMLDOMPropertyConfig */
	var htmlProps = {
	  /**
	   * Standard Properties
	   */
	  accept: true,
	  acceptCharset: true,
	  accessKey: true,
	  action: true,
	  allowFullScreen: true,
	  allowTransparency: true,
	  alt: true,
	  // specifies target context for links with `preload` type
	  as: true,
	  async: true,
	  autoComplete: true,
	  // autoFocus is polyfilled/normalized by AutoFocusUtils
	  // autoFocus: true,
	  autoPlay: true,
	  capture: true,
	  cellPadding: true,
	  cellSpacing: true,
	  charSet: true,
	  challenge: true,
	  checked: true,
	  cite: true,
	  classID: true,
	  className: true,
	  cols: true,
	  colSpan: true,
	  content: true,
	  contentEditable: true,
	  contextMenu: true,
	  controls: true,
	  coords: true,
	  crossOrigin: true,
	  data: true, // For `<object />` acts as `src`.
	  dateTime: true,
	  default: true,
	  defer: true,
	  dir: true,
	  disabled: true,
	  download: true,
	  draggable: true,
	  encType: true,
	  form: true,
	  formAction: true,
	  formEncType: true,
	  formMethod: true,
	  formNoValidate: true,
	  formTarget: true,
	  frameBorder: true,
	  headers: true,
	  height: true,
	  hidden: true,
	  high: true,
	  href: true,
	  hrefLang: true,
	  htmlFor: true,
	  httpEquiv: true,
	  icon: true,
	  id: true,
	  inputMode: true,
	  integrity: true,
	  is: true,
	  keyParams: true,
	  keyType: true,
	  kind: true,
	  label: true,
	  lang: true,
	  list: true,
	  loop: true,
	  low: true,
	  manifest: true,
	  marginHeight: true,
	  marginWidth: true,
	  max: true,
	  maxLength: true,
	  media: true,
	  mediaGroup: true,
	  method: true,
	  min: true,
	  minLength: true,
	  // Caution; `option.selected` is not updated if `select.multiple` is
	  // disabled with `removeAttribute`.
	  multiple: true,
	  muted: true,
	  name: true,
	  nonce: true,
	  noValidate: true,
	  open: true,
	  optimum: true,
	  pattern: true,
	  placeholder: true,
	  playsInline: true,
	  poster: true,
	  preload: true,
	  profile: true,
	  radioGroup: true,
	  readOnly: true,
	  referrerPolicy: true,
	  rel: true,
	  required: true,
	  reversed: true,
	  role: true,
	  rows: true,
	  rowSpan: true,
	  sandbox: true,
	  scope: true,
	  scoped: true,
	  scrolling: true,
	  seamless: true,
	  selected: true,
	  shape: true,
	  size: true,
	  sizes: true,
	  span: true,
	  spellCheck: true,
	  src: true,
	  srcDoc: true,
	  srcLang: true,
	  srcSet: true,
	  start: true,
	  step: true,
	  style: true,
	  summary: true,
	  tabIndex: true,
	  target: true,
	  title: true,
	  // Setting .type throws on non-<input> tags
	  type: true,
	  useMap: true,
	  value: true,
	  width: true,
	  wmode: true,
	  wrap: true,
	
	  /**
	   * RDFa Properties
	   */
	  about: true,
	  datatype: true,
	  inlist: true,
	  prefix: true,
	  // property is also supported for OpenGraph in meta tags.
	  property: true,
	  resource: true,
	  typeof: true,
	  vocab: true,
	
	  /**
	   * Non-standard Properties
	   */
	  // autoCapitalize and autoCorrect are supported in Mobile Safari for
	  // keyboard hints.
	  autoCapitalize: true,
	  autoCorrect: true,
	  // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	  autoSave: true,
	  // color is for Safari mask-icon link
	  color: true,
	  // itemProp, itemScope, itemType are for
	  // Microdata support. See http://schema.org/docs/gs.html
	  itemProp: true,
	  itemScope: true,
	  itemType: true,
	  // itemID and itemRef are for Microdata support as well but
	  // only specified in the WHATWG spec document. See
	  // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	  itemID: true,
	  itemRef: true,
	  // results show looking glass icon and recent searches on input
	  // search fields in WebKit/Blink
	  results: true,
	  // IE-only attribute that specifies security restrictions on an iframe
	  // as an alternative to the sandbox attribute on IE<10
	  security: true,
	  // IE-only attribute that controls focus behavior
	  unselectable: 0
	};
	
	var svgProps = {
	  accentHeight: true,
	  accumulate: true,
	  additive: true,
	  alignmentBaseline: true,
	  allowReorder: true,
	  alphabetic: true,
	  amplitude: true,
	  arabicForm: true,
	  ascent: true,
	  attributeName: true,
	  attributeType: true,
	  autoReverse: true,
	  azimuth: true,
	  baseFrequency: true,
	  baseProfile: true,
	  baselineShift: true,
	  bbox: true,
	  begin: true,
	  bias: true,
	  by: true,
	  calcMode: true,
	  capHeight: true,
	  clip: true,
	  clipPath: true,
	  clipRule: true,
	  clipPathUnits: true,
	  colorInterpolation: true,
	  colorInterpolationFilters: true,
	  colorProfile: true,
	  colorRendering: true,
	  contentScriptType: true,
	  contentStyleType: true,
	  cursor: true,
	  cx: true,
	  cy: true,
	  d: true,
	  decelerate: true,
	  descent: true,
	  diffuseConstant: true,
	  direction: true,
	  display: true,
	  divisor: true,
	  dominantBaseline: true,
	  dur: true,
	  dx: true,
	  dy: true,
	  edgeMode: true,
	  elevation: true,
	  enableBackground: true,
	  end: true,
	  exponent: true,
	  externalResourcesRequired: true,
	  fill: true,
	  fillOpacity: true,
	  fillRule: true,
	  filter: true,
	  filterRes: true,
	  filterUnits: true,
	  floodColor: true,
	  floodOpacity: true,
	  focusable: true,
	  fontFamily: true,
	  fontSize: true,
	  fontSizeAdjust: true,
	  fontStretch: true,
	  fontStyle: true,
	  fontVariant: true,
	  fontWeight: true,
	  format: true,
	  from: true,
	  fx: true,
	  fy: true,
	  g1: true,
	  g2: true,
	  glyphName: true,
	  glyphOrientationHorizontal: true,
	  glyphOrientationVertical: true,
	  glyphRef: true,
	  gradientTransform: true,
	  gradientUnits: true,
	  hanging: true,
	  horizAdvX: true,
	  horizOriginX: true,
	  ideographic: true,
	  imageRendering: true,
	  in: true,
	  in2: true,
	  intercept: true,
	  k: true,
	  k1: true,
	  k2: true,
	  k3: true,
	  k4: true,
	  kernelMatrix: true,
	  kernelUnitLength: true,
	  kerning: true,
	  keyPoints: true,
	  keySplines: true,
	  keyTimes: true,
	  lengthAdjust: true,
	  letterSpacing: true,
	  lightingColor: true,
	  limitingConeAngle: true,
	  local: true,
	  markerEnd: true,
	  markerMid: true,
	  markerStart: true,
	  markerHeight: true,
	  markerUnits: true,
	  markerWidth: true,
	  mask: true,
	  maskContentUnits: true,
	  maskUnits: true,
	  mathematical: true,
	  mode: true,
	  numOctaves: true,
	  offset: true,
	  opacity: true,
	  operator: true,
	  order: true,
	  orient: true,
	  orientation: true,
	  origin: true,
	  overflow: true,
	  overlinePosition: true,
	  overlineThickness: true,
	  paintOrder: true,
	  panose1: true,
	  pathLength: true,
	  patternContentUnits: true,
	  patternTransform: true,
	  patternUnits: true,
	  pointerEvents: true,
	  points: true,
	  pointsAtX: true,
	  pointsAtY: true,
	  pointsAtZ: true,
	  preserveAlpha: true,
	  preserveAspectRatio: true,
	  primitiveUnits: true,
	  r: true,
	  radius: true,
	  refX: true,
	  refY: true,
	  renderingIntent: true,
	  repeatCount: true,
	  repeatDur: true,
	  requiredExtensions: true,
	  requiredFeatures: true,
	  restart: true,
	  result: true,
	  rotate: true,
	  rx: true,
	  ry: true,
	  scale: true,
	  seed: true,
	  shapeRendering: true,
	  slope: true,
	  spacing: true,
	  specularConstant: true,
	  specularExponent: true,
	  speed: true,
	  spreadMethod: true,
	  startOffset: true,
	  stdDeviation: true,
	  stemh: true,
	  stemv: true,
	  stitchTiles: true,
	  stopColor: true,
	  stopOpacity: true,
	  strikethroughPosition: true,
	  strikethroughThickness: true,
	  string: true,
	  stroke: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeLinecap: true,
	  strokeLinejoin: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true,
	  surfaceScale: true,
	  systemLanguage: true,
	  tableValues: true,
	  targetX: true,
	  targetY: true,
	  textAnchor: true,
	  textDecoration: true,
	  textRendering: true,
	  textLength: true,
	  to: true,
	  transform: true,
	  u1: true,
	  u2: true,
	  underlinePosition: true,
	  underlineThickness: true,
	  unicode: true,
	  unicodeBidi: true,
	  unicodeRange: true,
	  unitsPerEm: true,
	  vAlphabetic: true,
	  vHanging: true,
	  vIdeographic: true,
	  vMathematical: true,
	  values: true,
	  vectorEffect: true,
	  version: true,
	  vertAdvY: true,
	  vertOriginX: true,
	  vertOriginY: true,
	  viewBox: true,
	  viewTarget: true,
	  visibility: true,
	  widths: true,
	  wordSpacing: true,
	  writingMode: true,
	  x: true,
	  xHeight: true,
	  x1: true,
	  x2: true,
	  xChannelSelector: true,
	  xlinkActuate: true,
	  xlinkArcrole: true,
	  xlinkHref: true,
	  xlinkRole: true,
	  xlinkShow: true,
	  xlinkTitle: true,
	  xlinkType: true,
	  xmlBase: true,
	  xmlns: true,
	  xmlnsXlink: true,
	  xmlLang: true,
	  xmlSpace: true,
	  y: true,
	  y1: true,
	  y2: true,
	  yChannelSelector: true,
	  z: true,
	  zoomAndPan: true
	};
	
	/* From DOMProperty */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	
	var hasOwnProperty = {}.hasOwnProperty;
	
	exports.default = function (name) {
	  return hasOwnProperty.call(htmlProps, name) || hasOwnProperty.call(svgProps, name) || isCustomAttribute(name.toLowerCase()) || hasOwnProperty.call(reactProps, name);
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = doHash;
	// murmurhash2 via https://gist.github.com/raycmorgan/588423
	
	function doHash(str, seed) {
	  var m = 0x5bd1e995;
	  var r = 24;
	  var h = seed ^ str.length;
	  var length = str.length;
	  var currentIndex = 0;
	
	  while (length >= 4) {
	    var k = UInt32(str, currentIndex);
	
	    k = Umul32(k, m);
	    k ^= k >>> r;
	    k = Umul32(k, m);
	
	    h = Umul32(h, m);
	    h ^= k;
	
	    currentIndex += 4;
	    length -= 4;
	  }
	
	  switch (length) {
	    case 3:
	      h ^= UInt16(str, currentIndex);
	      h ^= str.charCodeAt(currentIndex + 2) << 16;
	      h = Umul32(h, m);
	      break;
	
	    case 2:
	      h ^= UInt16(str, currentIndex);
	      h = Umul32(h, m);
	      break;
	
	    case 1:
	      h ^= str.charCodeAt(currentIndex);
	      h = Umul32(h, m);
	      break;
	  }
	
	  h ^= h >>> 13;
	  h = Umul32(h, m);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	function UInt32(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
	}
	
	function UInt16(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
	}
	
	function Umul32(n, m) {
	  n = n | 0;
	  m = m | 0;
	  var nlo = n & 0xffff;
	  var nhi = n >>> 16;
	  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
	  return res;
	}
	module.exports = exports["default"];

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	 *          __        ___
	 *    _____/ /___  __/ (_)____
	 *   / ___/ __/ / / / / / ___/
	 *  (__  ) /_/ /_/ / / (__  )
	 * /____/\__/\__, /_/_/____/
	 *          /____/
	 *
	 * light - weight css preprocessor @licence MIT
	 */
	(function (factory) {/* eslint-disable */
		 true ? (module['exports'] = factory(null)) :
			typeof define === 'function' && define['amd'] ? define(factory(null)) :
				(window['stylis'] = factory(null))
	}(/** @param {*=} options */function factory (options) {/* eslint-disable */
	
		'use strict'
	
		/**
		 * Notes
		 *
		 * The ['<method name>'] pattern is used to support closure compiler
		 * the jsdoc signatures are also used to the same effect
		 *
		 * ----
		 *
		 * int + int + int === n4 [faster]
		 *
		 * vs
		 *
		 * int === n1 && int === n2 && int === n3
		 *
		 * ----
		 *
		 * switch (int) { case ints...} [faster]
		 *
		 * vs
		 *
		 * if (int == 1 && int === 2 ...)
		 *
		 * ----
		 *
		 * The (first*n1 + second*n2 + third*n3) format used in the property parser
		 * is a simple way to hash the sequence of characters
		 * taking into account the index they occur in
		 * since any number of 3 character sequences could produce duplicates.
		 *
		 * On the other hand sequences that are directly tied to the index of the character
		 * resolve a far more accurate measure, it's also faster
		 * to evaluate one condition in a switch statement
		 * than three in an if statement regardless of the added math.
		 *
		 * This allows the vendor prefixer to be both small and fast.
		 */
	
		var nullptn = /^\0+/g /* matches leading null characters */
		var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
		var colonptn = /: */g /* splits animation rules */
		var cursorptn = /zoo|gra/ /* assert cursor varient */
		var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
		var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
		var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
		var elementptn = / *[\0] */g /* selector elements */
		var selectorptn = /,\r+?/g /* splits selectors */
		var andptn = /([\t\r\n ])*\f?&/g /* match & */
		var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
		var invalidptn = /\W+/g /* removes invalid characters from keyframes */
		var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
		var plcholdrptn = /::(place)/g /* match ::placeholder varient */
		var readonlyptn = /:(read-only)/g /* match :read-only varient */
		var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
		var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
		var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
		var whiteptn = /\s{2,}/g /* matches repeating whitespace */
		var pseudoptn = /([^\(])(:+) */g /* pseudo element */
		var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
		var gradientptn = /([\w-]+t\()/g /* match *gradient property */
		var supportsptn = /\(\s*([^]*?)\s*\)/g /* match supports (groups) */
		var propertyptn = /([^]*?);/g /* match properties leading semicolon */
		var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
		var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
		var trimptn = /[ \t]+$/ /* match tail whitspace */
	
		/* vendors */
		var webkit = '-webkit-'
		var moz = '-moz-'
		var ms = '-ms-'
	
		/* character codes */
		var SEMICOLON = 59 /* ; */
		var CLOSEBRACES = 125 /* } */
		var OPENBRACES = 123 /* { */
		var OPENPARENTHESES = 40 /* ( */
		var CLOSEPARENTHESES = 41 /* ) */
		var OPENBRACKET = 91 /* [ */
		var CLOSEBRACKET = 93 /* ] */
		var NEWLINE = 10 /* \n */
		var CARRIAGE = 13 /* \r */
		var TAB = 9 /* \t */
		var AT = 64 /* @ */
		var SPACE = 32 /*   */
		var AND = 38 /* & */
		var DASH = 45 /* - */
		var UNDERSCORE = 95 /* _ */
		var STAR = 42 /* * */
		var COMMA = 44 /* , */
		var COLON = 58 /* : */
		var SINGLEQUOTE = 39 /* ' */
		var DOUBLEQUOTE = 34 /* " */
		var FOWARDSLASH = 47 /* / */
		var GREATERTHAN = 62 /* > */
		var PLUS = 43 /* + */
		var TILDE = 126 /* ~ */
		var NULL = 0 /* \0 */
		var FORMFEED = 12 /* \f */
		var VERTICALTAB = 11 /* \v */
	
		/* special identifiers */
		var KEYFRAME = 107 /* k */
		var MEDIA = 109 /* m */
		var SUPPORTS = 115 /* s */
		var PLACEHOLDER = 112 /* p */
		var READONLY = 111 /* o */
		var IMPORT = 169 /* <at>i */
		var CHARSET = 163 /* <at>c */
		var DOCUMENT = 100 /* <at>d */
		var PAGE = 112 /* <at>p */
	
		var column = 1 /* current column */
		var line = 1 /* current line numebr */
		var pattern = 0 /* :pattern */
	
		var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
		var prefix = 1 /* vendor prefix */
		var escape = 1 /* escape :global() pattern */
		var compress = 0 /* compress output */
		var semicolon = 0 /* no/semicolon option */
		var preserve = 0 /* preserve empty selectors */
	
		/* empty reference */
		var array = []
	
		/* plugins */
		var plugins = []
		var plugged = 0
		var should = null
	
		/* plugin context */
		var POSTS = -2
		var PREPS = -1
		var UNKWN = 0
		var PROPS = 1
		var BLCKS = 2
		var ATRUL = 3
	
		/* plugin newline context */
		var unkwn = 0
	
		/* keyframe animation */
		var keyed = 1
		var key = ''
	
		/* selector namespace */
		var nscopealt = ''
		var nscope = ''
	
		/**
		 * Compile
		 *
		 * @param {Array<string>} parent
		 * @param {Array<string>} current
		 * @param {string} body
		 * @param {number} id
		 * @param {number} depth
		 * @return {string}
		 */
		function compile (parent, current, body, id, depth) {
			var bracket = 0 /* brackets [] */
			var comment = 0 /* comments /* // or /* */
			var parentheses = 0 /* functions () */
			var quote = 0 /* quotes '', "" */
	
			var first = 0 /* first character code */
			var second = 0 /* second character code */
			var code = 0 /* current character code */
			var tail = 0 /* previous character code */
			var trail = 0 /* character before previous code */
			var peak = 0 /* previous non-whitespace code */
	
			var counter = 0 /* count sequence termination */
			var context = 0 /* track current context */
			var atrule = 0 /* track @at-rule context */
			var pseudo = 0 /* track pseudo token index */
			var caret = 0 /* current character index */
			var format = 0 /* control character formating context */
			var insert = 0 /* auto semicolon insertion */
			var invert = 0 /* inverted selector pattern */
			var length = 0 /* generic length address */
			var eof = body.length /* end of file(length) */
			var eol = eof - 1 /* end of file(characters) */
	
			var char = '' /* current character */
			var chars = '' /* current buffer of characters */
			var child = '' /* next buffer of characters */
			var out = '' /* compiled body */
			var children = '' /* compiled children */
			var flat = '' /* compiled leafs */
			var selector /* generic selector address */
			var result /* generic address */
	
			// ...build body
			while (caret < eof) {
				code = body.charCodeAt(caret)
	
				// eof varient
				if (caret === eol) {
					// last character + noop context, add synthetic padding for noop context to terminate
					if (comment + quote + parentheses + bracket !== 0) {
						if (comment !== 0) {
							code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
						}
	
						quote = parentheses = bracket = 0
						eof++
						eol++
					}
				}
	
				if (comment + quote + parentheses + bracket === 0) {
					// eof varient
					if (caret === eol) {
						if (format > 0) {
							chars = chars.replace(formatptn, '')
						}
	
						if (chars.trim().length > 0) {
							switch (code) {
								case SPACE:
								case TAB:
								case SEMICOLON:
								case CARRIAGE:
								case NEWLINE: {
									break
								}
								default: {
									chars += body.charAt(caret)
								}
							}
	
							code = SEMICOLON
						}
					}
	
					// auto semicolon insertion
					if (insert === 1) {
						switch (code) {
							// false flags
							case OPENBRACES:
							case COMMA: {
								insert = 0
								break
							}
							// ignore
							case TAB:
							case CARRIAGE:
							case NEWLINE:
							case SPACE: {
								break
							}
							// valid
							default: {
								caret--
								code = SEMICOLON
							}
						}
					}
	
					// token varient
					switch (code) {
						case OPENBRACES: {
							chars = chars.trim()
							first = chars.charCodeAt(0)
							counter = 1
							length = ++caret
	
							while (caret < eof) {
								code = body.charCodeAt(caret)
	
								switch (code) {
									case OPENBRACES: {
										counter++
										break
									}
									case CLOSEBRACES: {
										counter--
										break
									}
								}
	
								if (counter === 0) {
									break
								}
	
								caret++
							}
	
							child = body.substring(length, caret)
	
							if (first === NULL) {
								first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
							}
	
							switch (first) {
								// @at-rule
								case AT: {
									if (format > 0) {
										chars = chars.replace(formatptn, '')
									}
	
									second = chars.charCodeAt(1)
	
									switch (second) {
										case DOCUMENT:
										case MEDIA:
										case SUPPORTS:
										case DASH: {
											selector = current
											break
										}
										default: {
											selector = array
										}
									}
	
									child = compile(current, selector, child, second, depth+1)
									length = child.length
	
									// preserve empty @at-rule
									if (preserve > 0 && length === 0) {
										length = chars.length
									}
	
									// execute plugins, @at-rule context
									if (plugged > 0) {
										selector = select(array, chars, invert)
										result = proxy(ATRUL, child, selector, current, line, column, length, second, depth)
										chars = selector.join('')
	
										if (result !== void 0) {
											if ((length = (child = result.trim()).length) === 0) {
												second = 0
												child = ''
											}
										}
									}
	
									if (length > 0) {
										switch (second) {
											case SUPPORTS: {
												chars = chars.replace(supportsptn, supports)
											}
											case DOCUMENT:
											case MEDIA:
											case DASH: {
												child = chars + '{' + child + '}'
												break
											}
											case KEYFRAME: {
												chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
												child = chars + '{' + child + '}'
	
												if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
													child = '@' + webkit + child + '@' + child
												} else {
													child = '@' + child
												}
												break
											}
											default: {
												child = chars + child
	
												if (id === PAGE) {
													child = (out += child, '')
												}
											}
										}
									} else {
										child = ''
									}
	
									break
								}
								// selector
								default: {
									child = compile(current, select(current, chars, invert), child, id, depth+1)
								}
							}
	
							children += child
	
							// reset
							context = 0
							insert = 0
							pseudo = 0
							format = 0
							invert = 0
							atrule = 0
							chars = ''
							child = ''
							code = body.charCodeAt(++caret)
							break
						}
						case CLOSEBRACES:
						case SEMICOLON: {
							chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()
	
							if ((length = chars.length) > 1) {
								// monkey-patch missing colon
								if (pseudo === 0) {
									first = chars.charCodeAt(0)
	
									// first character is a letter or dash, buffer has a space character
									if ((first === DASH || first > 96 && first < 123)) {
										length = (chars = chars.replace(' ', ':')).length
									}
								}
	
								// execute plugins, property context
								if (plugged > 0) {
									if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth)) !== void 0) {
										if ((length = (chars = result.trim()).length) === 0) {
											chars = '\0\0'
										}
									}
								}
	
								first = chars.charCodeAt(0)
								second = chars.charCodeAt(1)
	
								switch (first + second) {
									case NULL: {
										break
									}
									case IMPORT:
									case CHARSET: {
										flat += chars + body.charAt(caret)
										break
									}
									default: {
										if (chars.charCodeAt(length-1) === COLON)
											break
	
										out += property(chars, first, second, chars.charCodeAt(2))
									}
								}
							}
	
							// reset
							context = 0
							insert = 0
							pseudo = 0
							format = 0
							invert = 0
							chars = ''
							code = body.charCodeAt(++caret)
							break
						}
					}
				}
	
				// parse characters
				switch (code) {
					case CARRIAGE:
					case NEWLINE: {
						// auto insert semicolon
						if (comment + quote + parentheses + bracket + semicolon === 0) {
							// valid non-whitespace characters that
							// may precede a newline
							switch (peak) {
								case CLOSEPARENTHESES:
								case SINGLEQUOTE:
								case DOUBLEQUOTE:
								case AT:
								case TILDE:
								case GREATERTHAN:
								case STAR:
								case PLUS:
								case FOWARDSLASH:
								case DASH:
								case COLON:
								case COMMA:
								case SEMICOLON:
								case OPENBRACES:
								case CLOSEBRACES: {
									break
								}
								default: {
									// current buffer has a colon
									if (pseudo > 0) {
										insert = 1
									}
								}
							}
						}
	
						// terminate line comment
						if (comment === FOWARDSLASH) {
							comment = 0
						} else if (cascade + context === 0) {
							format = 1
							chars += '\0'
						}
	
						// execute plugins, newline context
						if (plugged * unkwn > 0) {
							proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth)
						}
	
						// next line, reset column position
						column = 1
						line++
						break
					}
					case SEMICOLON:
					case CLOSEBRACES: {
						if (comment + quote + parentheses + bracket === 0) {
							column++
							break
						}
					}
					default: {
						// increment column position
						column++
	
						// current character
						char = body.charAt(caret)
	
						// remove comments, escape functions, strings, attributes and prepare selectors
						switch (code) {
							case TAB:
							case SPACE: {
								if (quote + bracket + comment === 0) {
									switch (tail) {
										case COMMA:
										case COLON:
										case TAB:
										case SPACE: {
											char = ''
											break
										}
										default: {
											if (code !== SPACE) {
												char = ' '
											}
										}
									}
								}
								break
							}
							// escape breaking control characters
							case NULL: {
								char = '\\0'
								break
							}
							case FORMFEED: {
								char = '\\f'
								break
							}
							case VERTICALTAB: {
								char = '\\v'
								break
							}
							// &
							case AND: {
								// inverted selector pattern i.e html &
								if (quote + comment + bracket === 0 && cascade > 0) {
									invert = 1
									format = 1
									char = '\f' + char
								}
								break
							}
							// ::p<l>aceholder, l
							// :read-on<l>y, l
							case 108: {
								if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
									switch (caret - pseudo) {
										// ::placeholder
										case 2: {
											if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
												pattern = tail
											}
										}
										// :read-only
										case 8: {
											if (trail === READONLY) {
												pattern = trail
											}
										}
									}
								}
								break
							}
							// :<pattern>
							case COLON: {
								if (quote + comment + bracket === 0) {
									pseudo = caret
								}
								break
							}
							// selectors
							case COMMA: {
								if (comment + parentheses + quote + bracket === 0) {
									format = 1
									char += '\r'
								}
								break
							}
							// quotes
							case DOUBLEQUOTE: {
								if (comment === 0) {
									quote = quote === code ? 0 : (quote === 0 ? code : quote)
								}
								break
							}
							case SINGLEQUOTE: {
								if (comment === 0) {
									quote = quote === code ? 0 : (quote === 0 ? code : quote)
								}
								break
							}
							// attributes
							case OPENBRACKET: {
								if (quote + comment + parentheses === 0) {
									bracket++
								}
								break
							}
							case CLOSEBRACKET: {
								if (quote + comment + parentheses === 0) {
									bracket--
								}
								break
							}
							// functions
							case CLOSEPARENTHESES: {
								if (quote + comment + bracket === 0) {
									parentheses--
								}
								break
							}
							case OPENPARENTHESES: {
								if (quote + comment + bracket === 0) {
									if (context === 0) {
										switch (tail*2 + trail*3) {
											// :matches
											case 533: {
												break
											}
											// :global, :not, :nth-child etc...
											default: {
												counter = 0
												context = 1
											}
										}
									}
	
									parentheses++
								}
								break
							}
							case AT: {
								if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
									atrule = 1
								}
								break
							}
							// block/line comments
							case STAR:
							case FOWARDSLASH: {
								if (quote + bracket + parentheses > 0) {
									break
								}
	
								switch (comment) {
									// initialize line/block comment context
									case 0: {
										switch (code*2 + body.charCodeAt(caret+1)*3) {
											// //
											case 235: {
												comment = FOWARDSLASH
												break
											}
											// /*
											case 220: {
												length = caret
												comment = STAR
												break
											}
										}
										break
									}
									// end block comment context
									case STAR: {
										if (code === FOWARDSLASH && tail === STAR) {
											// /*<!> ... */, !
											if (body.charCodeAt(length+2) === 33) {
												out += body.substring(length, caret+1)
											}
											char = ''
											comment = 0
										}
									}
								}
							}
						}
	
						// ignore comment blocks
						if (comment === 0) {
							// aggressive isolation mode, divide each individual selector
							// including selectors in :not function but excluding selectors in :global function
							if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
								switch (code) {
									case COMMA:
									case TILDE:
									case GREATERTHAN:
									case PLUS:
									case CLOSEPARENTHESES:
									case OPENPARENTHESES: {
										if (context === 0) {
											// outside of an isolated context i.e nth-child(<...>)
											switch (tail) {
												case TAB:
												case SPACE:
												case NEWLINE:
												case CARRIAGE: {
													char = char + '\0'
													break
												}
												default: {
													char = '\0' + char + (code === COMMA ? '' : '\0')
												}
											}
											format = 1
										} else {
											// within an isolated context, sleep untill it's terminated
											switch (code) {
												case OPENPARENTHESES: {
													context = ++counter
													break
												}
												case CLOSEPARENTHESES: {
													if ((context = --counter) === 0) {
														format = 1
														char += '\0'
													}
													break
												}
											}
										}
										break
									}
									case TAB:
									case SPACE: {
										switch (tail) {
											case NULL:
											case OPENBRACES:
											case CLOSEBRACES:
											case SEMICOLON:
											case COMMA:
											case FORMFEED:
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												break
											}
											default: {
												// ignore in isolated contexts
												if (context === 0) {
													format = 1
													char += '\0'
												}
											}
										}
									}
								}
							}
	
							// concat buffer of characters
							chars += char
	
							// previous non-whitespace character code
							if (code !== SPACE && code !== TAB) {
								peak = code
							}
						}
					}
				}
	
				// tail character codes
				trail = tail
				tail = code
	
				// visit every character
				caret++
			}
	
			length = out.length
	
			// preserve empty selector
	 		if (preserve > 0) {
	 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
	 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
						length = current.join(',').length + 2
	 				}
	 			}
			}
	
			if (length > 0) {
				// cascade isolation mode?
				selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current
	
				// execute plugins, block context
				if (plugged > 0) {
					result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth)
	
					if (result !== void 0 && (out = result).length === 0) {
						return flat + out + children
					}
				}
	
				out = selector.join(',') + '{' + out + '}'
	
				if (prefix*pattern !== 0) {
					if (prefix === 2 && !vendor(out, 2))
						pattern = 0
	
					switch (pattern) {
						// ::read-only
						case READONLY: {
							out = out.replace(readonlyptn, ':'+moz+'$1')+out
							break
						}
						// ::placeholder
						case PLACEHOLDER: {
							out = (
								out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
								out.replace(plcholdrptn, '::' + moz + '$1') +
								out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
							)
							break
						}
					}
	
					pattern = 0
				}
			}
	
			return flat + out + children
		}
	
		/**
		 * Select
		 *
		 * @param {Array<string>} parent
		 * @param {string} current
		 * @param {number} invert
		 * @return {Array<string>}
		 */
		function select (parent, current, invert) {
			var selectors = current.trim().split(selectorptn)
			var out = selectors
	
			var length = selectors.length
			var l = parent.length
	
			switch (l) {
				// 0-1 parent selectors
				case 0:
				case 1: {
					for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
						out[i] = scope(selector, out[i], invert, l).trim()
					}
					break
				}
				// >2 parent selectors, nested
				default: {
					for (var i = 0, j = 0, out = []; i < length; ++i) {
						for (var k = 0; k < l; ++k) {
							out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
						}
					}
				}
			}
	
			return out
		}
	
		/**
		 * Scope
		 *
		 * @param {string} parent
		 * @param {string} current
		 * @param {number} invert
		 * @param {number} level
		 * @return {string}
		 */
		function scope (parent, current, invert, level) {
			var selector = current
			var code = selector.charCodeAt(0)
	
			// trim leading whitespace
			if (code < 33) {
				code = (selector = selector.trim()).charCodeAt(0)
			}
	
			switch (code) {
				// &
				case AND: {
					switch (cascade + level) {
						case 0:
						case 1: {
							if (parent.trim().length === 0) {
								break
							}
						}
						default: {
							return selector.replace(andptn, '$1'+parent.trim())
						}
					}
					break
				}
				// :
				case COLON: {
					switch (selector.charCodeAt(1)) {
						// g in :global
						case 103: {
							if (escape > 0 && cascade > 0) {
								return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
							}
							break
						}
						default: {
							// :hover
							return parent.trim() + selector
						}
					}
				}
				default: {
					// html &
					if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
						return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
					}
				}
			}
	
			return parent + selector
		}
	
		/**
		 * Property
		 *
		 * @param {string} input
		 * @param {number} first
		 * @param {number} second
		 * @param {number} third
		 * @return {string}
		 */
		function property (input, first, second, third) {
			var index = 0
			var out = input + ';'
			var hash = (first*2) + (second*3) + (third*4)
			var cache
	
			// animation: a, n, i characters
			if (hash === 944) {
				return animation(out)
			} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
				return out
			}
	
			// vendor prefix
			switch (hash) {
				// text-decoration/text-size-adjust: t, e, x
				case 1015: {
					// text-size-adjust, -
					return out.charCodeAt(9) === DASH ? webkit + out + out : out
				}
				// filter/fill f, i, l
				case 951: {
					// filter, t
					return out.charCodeAt(3) === 116 ? webkit + out + out : out
				}
				// color/column, c, o, l
				case 963: {
					// column, n
					return out.charCodeAt(5) === 110 ? webkit + out + out : out
				}
				// box-decoration-break, b, o, x
				case 1009: {
					if (out.charCodeAt(4) !== 100) {
						break
					}
				}
				// mask, m, a, s
				// clip-path, c, l, i
				case 969:
				case 942: {
					return webkit + out + out
				}
				// appearance: a, p, p
				case 978: {
					return webkit + out + moz + out + out
				}
				// hyphens: h, y, p
				// user-select: u, s, e
				case 1019:
				case 983: {
					return webkit + out + moz + out + ms + out + out
				}
				// background/backface-visibility, b, a, c
				case 883: {
					// backface-visibility, -
					return out.charCodeAt(8) === DASH ? webkit + out + out : out
				}
				// flex: f, l, e
				case 932: {
					if (out.charCodeAt(4) === DASH) {
						switch (out.charCodeAt(5)) {
							// flex-grow, g
							case 103: {
								return webkit + 'box-' + out.replace('-grow', '') + ms + out.replace('grow', 'positive') + out
							}
							// flex-shrink, s
							case 115: {
								return ms + out.replace('shrink', 'negative') + out
							}
							// flex-basis, b
							case 98: {
								return ms + out.replace('basis', 'preferred-size') + out
							}
						}
					}
	
					return webkit + out + ms + out + out
				}
				// order: o, r, d
				case 964: {
					return webkit + out + ms + 'flex' + '-' + out + out
				}
				// justify-items/justify-content, j, u, s
				case 1023: {
					// justify-content, c
					if (out.charCodeAt(8) !== 99) {
						break
					}
	
					cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
					return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
				}
				// cursor, c, u, r
				case 1005: {
					return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
				}
				// writing-mode, w, r, i
				case 1000: {
					cache = out.substring(13).trim()
					index = cache.indexOf('-') + 1
	
					switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
						// vertical-lr
						case 226: {
							cache = out.replace(writingptn, 'tb')
							break
						}
						// vertical-rl
						case 232: {
							cache = out.replace(writingptn, 'tb-rl')
							break
						}
						// horizontal-tb
						case 220: {
							cache = out.replace(writingptn, 'lr')
							break
						}
						default: {
							return out
						}
					}
	
					return webkit + out + ms + cache + out
				}
				// position: sticky
				case 1017: {
					if (out.indexOf('sticky', 9) === -1) {
						return out
					}
				}
				// display(flex/inline-flex/inline-box): d, i, s
				case 975: {
					index = (out = input).length - 10
					cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()
	
					switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
						// inline-
						case 203: {
							// inline-box
							if (cache.charCodeAt(8) < 111) {
								break
							}
						}
						// inline-box/sticky
						case 115: {
							out = out.replace(cache, webkit+cache)+';'+out
							break
						}
						// inline-flex
						// flex
						case 207:
						case 102: {
							out = (
								out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
								out.replace(cache, webkit+cache)+';'+
								out.replace(cache, ms+cache+'box')+';'+
								out
							)
						}
					}
	
					return out + ';'
				}
				// align-items, align-center, align-self: a, l, i, -
				case 938: {
					if (out.charCodeAt(5) === DASH) {
						switch (out.charCodeAt(6)) {
							// align-items, i
							case 105: {
								cache = out.replace('-items', '')
								return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
							}
							// align-self, s
							case 115: {
								return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
							}
							// align-content
							default: {
								return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '') + out
							}
						}
					}
					break
				}
				// width: min-content / width: max-content
				case 953: {
					if ((index = out.indexOf('-content', 9)) > 0) {
						// width: min-content / width: max-content
						if (out.charCodeAt(index - 3) === 109 && out.charCodeAt(index - 4) !== 45) {
							cache = out.substring(index - 3)
							return 'width:' + webkit + cache + 'width:' + moz + cache + 'width:' + cache
						}
					}
					break
				}
				// transform, transition: t, r, a
				case 962: {
					out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out
	
					// transitions
					if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
						return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
					}
	
					break
				}
			}
	
			return out
		}
	
		var i = 0
	
		/**
		 * Vendor
		 *
		 * @param {string} content
		 * @param {number} context
		 * @return {boolean}
		 */
		function vendor (content, context) {
			var index = content.indexOf(context === 1 ? ':' : '{')
			var key = content.substring(0, context !== 3 ? index : 10)
			var value = content.substring(index + 1, content.length - 1)
	
			return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
		}
	
		/**
		 * Supports
		 *
		 * @param {string} match
		 * @param {string} group
		 * @return {string}
		 */
		function supports (match, group) {
			var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))
	
			return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
		}
	
		/**
		 * Animation
		 *
		 * @param {string} input
		 * @return {string}
		 */
		function animation (input) {
			var length = input.length
			var index = input.indexOf(':', 9) + 1
			var declare = input.substring(0, index).trim()
			var out = input.substring(index, length-1).trim()
	
			switch (input.charCodeAt(9)*keyed) {
				case 0: {
					break
				}
				// animation-*, -
				case DASH: {
					// animation-name, n
					if (input.charCodeAt(10) !== 110) {
						break
					}
				}
				// animation/animation-name
				default: {
					// split in case of multiple animations
					var list = out.split((out = '', animationptn))
	
					for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
						var value = list[i]
						var items = value.split(propertiesptn)
	
						while (value = items[index]) {
							var peak = value.charCodeAt(0)
	
							if (keyed === 1 && (
								// letters
								(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
								// dash but not in sequence i.e --
								(peak === DASH && value.charCodeAt(1) !== DASH)
							)) {
								// not a number/function
								switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
									case 1: {
										switch (value) {
											// not a valid reserved keyword
											case 'infinite': case 'alternate': case 'backwards': case 'running':
											case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
											case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
											case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
											case 'initial': case 'unset': case 'step-start': case 'step-end': {
												break
											}
											default: {
												value += key
											}
										}
									}
								}
							}
	
							items[index++] = value
						}
	
						out += (i === 0 ? '' : ',') + items.join(' ')
					}
				}
			}
	
			out = declare + out + ';'
	
			if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
				return webkit + out + out
	
			return out
		}
	
		/**
		 * Isolate
		 *
		 * @param {Array<string>} current
		 */
		function isolate (current) {
			for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
				// split individual elements in a selector i.e h1 h2 === [h1, h2]
				var elements = current[i].split(elementptn)
				var out = ''
	
				for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
					// empty element
					if ((size = (element = elements[j]).length) === 0 && l > 1) {
						continue
					}
	
					tail = out.charCodeAt(out.length-1)
					code = element.charCodeAt(0)
					padding = ''
	
					if (j !== 0) {
						// determine if we need padding
						switch (tail) {
							case STAR:
							case TILDE:
							case GREATERTHAN:
							case PLUS:
							case SPACE:
							case OPENPARENTHESES:  {
								break
							}
							default: {
								padding = ' '
							}
						}
					}
	
					switch (code) {
						case AND: {
							element = padding + nscopealt
						}
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case CLOSEPARENTHESES:
						case OPENPARENTHESES: {
							break
						}
						case OPENBRACKET: {
							element = padding + element + nscopealt
							break
						}
						case COLON: {
							switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
								// :global
								case 530: {
									if (escape > 0) {
										element = padding + element.substring(8, size - 1)
										break
									}
								}
								// :hover, :nth-child(), ...
								default: {
									if (j < 1 || elements[j-1].length < 1) {
										element = padding + nscopealt + element
									}
								}
							}
							break
						}
						case COMMA: {
							padding = ''
						}
						default: {
							if (size > 1 && element.indexOf(':') > 0) {
								element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
							} else {
								element = padding + element + nscopealt
							}
						}
					}
	
					out += element
				}
	
				selector[i] = out.replace(formatptn, '').trim()
			}
	
			return selector
		}
	
		/**
		 * Proxy
		 *
		 * @param {number} context
		 * @param {string} content
		 * @param {Array<string>} selectors
		 * @param {Array<string>} parents
		 * @param {number} line
		 * @param {number} column
		 * @param {number} length
		 * @param {number} id
		 * @param {number} depth
		 * @return {(string|void|*)}
		 */
		function proxy (context, content, selectors, parents, line, column, length, id, depth) {
			for (var i = 0, out = content, next; i < plugged; ++i) {
				switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth)) {
					case void 0:
					case false:
					case true:
					case null: {
						break
					}
					default: {
						out = next
					}
				}
			}
	
			switch (out) {
				case void 0:
				case false:
				case true:
				case null:
				case content: {
					break
				}
				default: {
					return out
				}
			}
		}
	
		/**
		 * Minify
		 *
		 * @param {(string|*)} output
		 * @return {string}
		 */
		function minify (output) {
			return output
				.replace(formatptn, '')
				.replace(beforeptn, '')
				.replace(afterptn, '$1')
				.replace(tailptn, '$1')
				.replace(whiteptn, ' ')
		}
	
		/**
		 * Use
		 *
		 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
		 */
		function use (plugin) {
			switch (plugin) {
				case void 0:
				case null: {
					plugged = plugins.length = 0
					break
				}
				default: {
					switch (plugin.constructor) {
						case Array: {
							for (var i = 0, length = plugin.length; i < length; ++i) {
								use(plugin[i])
							}
							break
						}
						case Function: {
							plugins[plugged++] = plugin
							break
						}
						case Boolean: {
							unkwn = !!plugin|0
						}
					}
				}
	 		}
	
	 		return use
		}
	
		/**
		 * Set
		 *
		 * @param {*} options
		 */
		function set (options) {
			for (var name in options) {
				var value = options[name]
				switch (name) {
					case 'keyframe': keyed = value|0; break
					case 'global': escape = value|0; break
					case 'cascade': cascade = value|0; break
					case 'compress': compress = value|0; break
					case 'semicolon': semicolon = value|0; break
					case 'preserve': preserve = value|0; break
					case 'prefix':
						should = null
	
						if (!value) {
							prefix = 0
						} else if (typeof value !== 'function') {
							prefix = 1
						} else {
							prefix = 2
							should = value
						}
				}
			}
	
			return set
		}
	
		/**
		 * Stylis
		 *
		 * @param {string} selector
		 * @param {string} input
		 * @return {*}
		 */
		function stylis (selector, input) {
			if (this !== void 0 && this.constructor === stylis) {
				return factory(selector)
			}
	
			// setup
			var ns = selector
			var code = ns.charCodeAt(0)
	
			// trim leading whitespace
			if (code < 33) {
				code = (ns = ns.trim()).charCodeAt(0)
			}
	
			// keyframe/animation namespace
			if (keyed > 0) {
				key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
			}
	
			// reset, used to assert if a plugin is moneky-patching the return value
			code = 1
	
			// cascade/isolate
			if (cascade === 1) {
				nscope = ns
			} else {
				nscopealt = ns
			}
	
			var selectors = [nscope]
			var result
	
			// execute plugins, pre-process context
			if (plugged > 0) {
				result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0)
	
				if (result !== void 0 && typeof result === 'string') {
					input = result
				}
			}
	
			// build
			var output = compile(array, selectors, input, 0, 0)
	
			// execute plugins, post-process context
			if (plugged > 0) {
				result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0)
	
				// bypass minification
				if (result !== void 0 && typeof(output = result) !== 'string') {
					code = 0
				}
			}
	
			// reset
			key = ''
			nscope = ''
			nscopealt = ''
			pattern = 0
			line = 1
			column = 1
	
			return compress*code === 0 ? output : minify(output)
		}
	
		stylis['use'] = use
		stylis['set'] = set
	
		if (options !== void 0) {
			set(options)
		}
	
		return stylis
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)(module)))

/***/ }),

/***/ 202:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  0% {\n    bottom: -100px;\n  }\n  50% {\n    bottom: -100px;\n  }\n  100% { \n    bottom: 0;\n  }\n"], ["\n  0% {\n    bottom: -100px;\n  }\n  50% {\n    bottom: -100px;\n  }\n  100% { \n    bottom: 0;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  animation-name: ", ";\n  animation-duration: 1s;\n  background: ", ";\n  bottom: 0;\n  height: ", "px;\n  left: 0;\n  position: fixed;\n  width: 100%;\n\n  a {\n    color: ", ";\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    text-decoration: none;\n\n    b {\n      font-size: 1.2em;\n      font-weight: 300;\n      padding: 0 0.6em;\n      margin: 0;\n      float: left;\n      line-height: 0.5;\n    }\n  }\n\n  @media screen and (min-width: ", ") {\n    display: none;\n  }\n"], ["\n  animation-name: ", ";\n  animation-duration: 1s;\n  background: ", ";\n  bottom: 0;\n  height: ", "px;\n  left: 0;\n  position: fixed;\n  width: 100%;\n\n  a {\n    color: ", ";\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    text-decoration: none;\n\n    b {\n      font-size: 1.2em;\n      font-weight: 300;\n      padding: 0 0.6em;\n      margin: 0;\n      float: left;\n      line-height: 0.5;\n    }\n  }\n\n  @media screen and (min-width: ", ") {\n    display: none;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  display: block;\n  height: ", "px;\n  width: ", "px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n\n  svg {\n    width: 1.2em;\n    height: 1.2em;\n    fill: ", ";\n  }\n"], ["\n  background: ", ";\n  display: block;\n  height: ", "px;\n  width: ", "px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n\n  svg {\n    width: 1.2em;\n    height: 1.2em;\n    fill: ", ";\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SVGelem = __webpack_require__(153);
	
	var _SVGelem2 = _interopRequireDefault(_SVGelem);
	
	var _constants = __webpack_require__(155);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var wrapperShowUp = (0, _styledComponents.keyframes)(_templateObject);
	
	var Wrapper = _styledComponents2.default.footer(_templateObject2, wrapperShowUp, function (props) {
	  return props.theme.bottomBar.backgrounds.wrapper;
	}, function (props) {
	  return props.theme.bottomBar.sizes.height;
	}, function (props) {
	  return props.theme.bottomBar.colors.link;
	}, function (props) {
	  return props.theme.mediaQueryTresholds.L;
	});
	
	var SVGWrapper = _styledComponents2.default.span(_templateObject3, function (props) {
	  return props.theme.bottomBar.backgrounds.icon;
	}, function (props) {
	  return props.theme.bottomBar.sizes.height;
	}, function (props) {
	  return props.theme.bottomBar.sizes.height;
	}, function (props) {
	  return props.theme.bottomBar.colors.icon;
	});
	
	var BottomBar = function (_React$Component) {
	  _inherits(BottomBar, _React$Component);
	
	  function BottomBar() {
	    _classCallCheck(this, BottomBar);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BottomBar.prototype.render = function render() {
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/" },
	        _react2.default.createElement(
	          SVGWrapper,
	          null,
	          _react2.default.createElement(_SVGelem2.default, { svg: _constants.ICONS.HOME })
	        ),
	        _react2.default.createElement(
	          "b",
	          null,
	          "back Home"
	        )
	      )
	    );
	  };
	
	  return BottomBar;
	}(_react2.default.Component);
	
	exports.default = BottomBar;
	module.exports = exports["default"];

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(18);
	
	var _BottomBar = __webpack_require__(274);
	
	var _BottomBar2 = _interopRequireDefault(_BottomBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BottomBarContainer = function (_React$Component) {
	  _inherits(BottomBarContainer, _React$Component);
	
	  function BottomBarContainer() {
	    _classCallCheck(this, BottomBarContainer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BottomBarContainer.prototype.render = function render() {
	    return this.props.navigatorIsAside ? _react2.default.createElement(_BottomBar2.default, null) : null;
	  };
	
	  return BottomBarContainer;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    navigatorIsAside: state.navigator.isAside
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BottomBarContainer);
	module.exports = exports["default"];

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  height: 100%;\n  left: 0;\n  min-height: ", ";\n  position: absolute;\n  right: 0;\n  top: ", ";\n  transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1), background 0s;\n  overflow: auto;\n  z-index: 2;\n\n  @media screen and (min-width: ", ") {\n    left: ", ";\n  }\n"], ["\n  background: ", ";\n  height: 100%;\n  left: 0;\n  min-height: ", ";\n  position: absolute;\n  right: 0;\n  top: ", ";\n  transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1), background 0s;\n  overflow: auto;\n  z-index: 2;\n\n  @media screen and (min-width: ", ") {\n    left: ", ";\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  font-size: 1.05em;\n  height: 100%;\n  justify-content: center;\n  line-height: 1.5;\n  max-width: ", ";\n  margin-left: auto;\n  margin-right: auto;\n  padding: 2em;\n\n  @media screen and (min-width: ", ") {\n    p {\n      font-size: 1.1em;\n    }\n  }\n\n  a {\n    border-bottom: 1px solid ", ";\n    color: ", ";\n    font-weight: bold;\n    text-shadow: 2px 2px ", ",\n      -2px 2px ", ",\n      -2px -2px ", ",\n      -2px 2px ", ",\n      -2px 0 ", ",\n      2px 0 ", ";\n    display: inline-block;\n    line-height: 1.1;\n    text-decoration: none;\n    transition: 0.3s;\n\n    &:hover {\n      color: ", ";\n      border-color: ", ";\n    }\n  }\n"], ["\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  font-size: 1.05em;\n  height: 100%;\n  justify-content: center;\n  line-height: 1.5;\n  max-width: ", ";\n  margin-left: auto;\n  margin-right: auto;\n  padding: 2em;\n\n  @media screen and (min-width: ", ") {\n    p {\n      font-size: 1.1em;\n    }\n  }\n\n  a {\n    border-bottom: 1px solid ", ";\n    color: ", ";\n    font-weight: bold;\n    text-shadow: 2px 2px ", ",\n      -2px 2px ", ",\n      -2px -2px ", ",\n      -2px 2px ", ",\n      -2px 0 ", ",\n      2px 0 ", ";\n    display: inline-block;\n    line-height: 1.1;\n    text-decoration: none;\n    transition: 0.3s;\n\n    &:hover {\n      color: ", ";\n      border-color: ", ";\n    }\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  display: block;\n  margin-bottom: 1em;\n  width: 600px;\n  max-width: 80%;\n  fill: ", ";\n"], ["\n  display: block;\n  margin-bottom: 1em;\n  width: 600px;\n  max-width: 80%;\n  fill: ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  width: 64px;\n  height: 64px;\n  position: relative;\n  margin: 0 0 0 35em;\n\n  > span {\n    background: ", ";\n    color: ", ";\n    fill: currentColor;\n    border-radius: 100%;\n    display: block;\n    height: 44px;\n    width: 44px;\n    padding: 10px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  @media screen and (min-width: ", ") {\n    padding: 16px;\n  }\n"], ["\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  width: 64px;\n  height: 64px;\n  position: relative;\n  margin: 0 0 0 35em;\n\n  > span {\n    background: ", ";\n    color: ", ";\n    fill: currentColor;\n    border-radius: 100%;\n    display: block;\n    height: 44px;\n    width: 44px;\n    padding: 10px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  @media screen and (min-width: ", ") {\n    padding: 16px;\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  background: transparent url(", ") no-repeat;\n  padding-left: 10em;\n  min-height: 8em;\n"], ["\n  background: transparent url(", ") no-repeat;\n  padding-left: 10em;\n  min-height: 8em;\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SVGelem = __webpack_require__(153);
	
	var _SVGelem2 = _interopRequireDefault(_SVGelem);
	
	var _constants = __webpack_require__(155);
	
	var _siteConfig = __webpack_require__(21);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _avatar = __webpack_require__(202);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.info.backgrounds.wrapper;
	}, function (props) {
	  return props.appInitialState ? "100vh" : "0";
	}, function (props) {
	  return props.isRolledDown ? "0" : "-100%";
	}, function (props) {
	  return props.theme.mediaQueryTresholds.L;
	}, function (props) {
	  return props.navigatorIsAside ? props.theme.navigator.sizes.asideWidth : "0";
	});
	
	var Content = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.theme.info.colors.text;
	}, function (props) {
	  return props.theme.info.sizes.maxWidth;
	}, function (props) {
	  return props.theme.mediaQueryTresholds.L;
	}, function (props) {
	  return props.theme.info.colors.linkHover;
	}, function (props) {
	  return props.theme.info.colors.link;
	}, function (props) {
	  return props.theme.info.backgrounds.wrapper;
	}, function (props) {
	  return props.theme.info.backgrounds.wrapper;
	}, function (props) {
	  return props.theme.info.backgrounds.wrapper;
	}, function (props) {
	  return props.theme.info.backgrounds.wrapper;
	}, function (props) {
	  return props.theme.info.backgrounds.wrapper;
	}, function (props) {
	  return props.theme.info.backgrounds.wrapper;
	}, function (props) {
	  return props.theme.info.colors.linkHover;
	}, function (props) {
	  return props.theme.info.colors.link;
	});
	
	var Logo = _styledComponents2.default.span(_templateObject3, function (props) {
	  return props.theme.info.colors.text;
	});
	
	var CloseBtn = _styledComponents2.default.button(_templateObject4, function (props) {
	  return props.theme.info.backgrounds.btn;
	}, function (props) {
	  return props.theme.info.colors.btn;
	}, function (props) {
	  return props.theme.mediaQueryTresholds.M;
	});
	
	var Avatar = _styledComponents2.default.div(_templateObject5, _avatar2.default);
	
	var Info = function Info(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    {
	      isRolledDown: props.isRolledDown,
	      inTransition: props.inTransition,
	      navigatorIsAside: props.navigatorIsAside
	    },
	    _react2.default.createElement(
	      Content,
	      null,
	      _react2.default.createElement(
	        Logo,
	        null,
	        _react2.default.createElement(_SVGelem2.default, { svg: _constants.LOGOS.MAIN })
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          Avatar,
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            "Jon is a ",
	            _react2.default.createElement(
	              "a",
	              { href: "https://www.linkedin.com/in/jon-brisbin-5406a06/", target: "_blank", rel: "noopener" },
	              "Software Engineer"
	            ),
	            " with over two decades of experience architecting solutions in large-scale systems. He was a founding member of the ",
	            _react2.default.createElement(
	              "a",
	              { href: "https://github.com/reactor/reactor-core", target: "_blank", rel: "noopener" },
	              "Reactor Framework"
	            ),
	            " while working for ",
	            _react2.default.createElement(
	              "a",
	              { href: "https://pivotal.io/", target: "_blank", rel: "noopener" },
	              "Pivotal"
	            ),
	            " and helped push the industry forward with next-generation work to enable developers to quickly code applications with the ",
	            _react2.default.createElement(
	              "a",
	              { href: "https://github.com/spring-projects/spring-framework", target: "_blank", rel: "noopener" },
	              "Spring Framework"
	            ),
	            ". He also contributed key work to the Riak ecosystem while working at the then custodian of ",
	            _react2.default.createElement(
	              "a",
	              { href: "https://github.com/basho/riak", target: "_blank", rel: "noopener" },
	              "the Riak Open Source database"
	            ),
	            ", Basho. He is currently helping to develop the next generation of high-performance Application Performance Monitoring (APM) with the premier APM vendor of the future: ",
	            _react2.default.createElement(
	              "a",
	              { href: "https://www.instana.com/", target: "_blank", rel: "noopener" },
	              "Instana"
	            ),
	            "."
	          )
	        )
	      ),
	      _react2.default.createElement(
	        CloseBtn,
	        { onClick: props.btnOnClick, "aria-label": "Close" },
	        _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement(_SVGelem2.default, { svg: _constants.ICONS.CLOSE })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Info;
	
	//
	
	module.exports = exports["default"];

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(18);
	
	var _store = __webpack_require__(29);
	
	var _Info = __webpack_require__(276);
	
	var _Info2 = _interopRequireDefault(_Info);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfoContainer = function (_React$Component) {
	  _inherits(InfoContainer, _React$Component);
	
	  function InfoContainer(props) {
	    _classCallCheck(this, InfoContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.updateInfoInTransition = _this.updateInfoInTransition.bind(_this);
	    _this.state = {
	      screenRolledUp: false,
	      screenInTransition: false
	    };
	    return _this;
	  }
	
	  InfoContainer.prototype.updateInfoInTransition = function updateInfoInTransition(val) {
	    this.setState(function () {
	      return { screenInTransition: val };
	    });
	  };
	
	  InfoContainer.prototype.render = function render() {
	    return _react2.default.createElement(_Info2.default, {
	      isRolledDown: this.props.isRolledDown,
	      inTransition: this.props.inTransition,
	      btnOnClick: this.props.btnOnClick,
	      navigatorIsAside: this.props.navigatorIsAside
	    });
	  };
	
	  return InfoContainer;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    navigatorIsAside: state.navigator.isAside,
	    isRolledDown: state.info.isRolledDown,
	    inTransition: state.info.inTransition
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return { btnOnClick: function btnOnClick() {
	      return dispatch((0, _store.toggleInfoScreen)());
	    } };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InfoContainer);
	module.exports = exports["default"];

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n"], ["\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  bottom: 0;\n  background: ", ";\n  left: ", ";\n  padding-top: ", "px;\n  overflow: auto;\n  position: absolute;\n  top: 0;\n  width: ", ";\n\n  @media screen and (min-width: ", ") {\n    padding-top: ", "px;\n  }\n  @media screen and (min-width: ", ") {\n    display: block;\n    left: 0;\n    transition: all 0.6s ease;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: ", ";\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n  }\n\n  a {\n    display: block;\n    padding: ", ";\n    color: inherit;\n    text-decoration: none;\n    &:hover {\n      color: inherit;\n    }\n  }\n"], ["\n  display: ", ";\n  bottom: 0;\n  background: ", ";\n  left: ", ";\n  padding-top: ", "px;\n  overflow: auto;\n  position: absolute;\n  top: 0;\n  width: ", ";\n\n  @media screen and (min-width: ", ") {\n    padding-top: ", "px;\n  }\n  @media screen and (min-width: ", ") {\n    display: block;\n    left: 0;\n    transition: all 0.6s ease;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: ", ";\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n  }\n\n  a {\n    display: block;\n    padding: ", ";\n    color: inherit;\n    text-decoration: none;\n    &:hover {\n      color: inherit;\n    }\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-weight: 300;\n  color: ", ";\n  text-transform: uppercase;\n  margin: 1.4em 0 0 1.3em;\n  letter-spacing: 0.2em;\n  font-size: 0.9em;\n"], ["\n  display: ", ";\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-weight: 300;\n  color: ", ";\n  text-transform: uppercase;\n  margin: 1.4em 0 0 1.3em;\n  letter-spacing: 0.2em;\n  font-size: 0.9em;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  list-style: none;\n  max-width: ", ";\n  margin: 0;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0;\n\n  @media screen and (min-width: ", ") {\n    padding: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: ", ";\n  }\n"], ["\n  display: ", ";\n  list-style: none;\n  max-width: ", ";\n  margin: 0;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0;\n\n  @media screen and (min-width: ", ") {\n    padding: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: ", ";\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\nfrom {\n  opacity: 0;\n}\nto {\n  opacity: 1;\n}\n"], ["\nfrom {\n  opacity: 0;\n}\nto {\n  opacity: 1;\n}\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  animation-name: ", ";\n  animation-duration: 0.5s;\n  background: ", ";\n  border-left: 0.4em solid\n    ", ";\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  transition: background 0.5s;\n  &:first-child {\n    border-top: ", ";\n  }\n"], ["\n  animation-name: ", ";\n  animation-duration: 0.5s;\n  background: ", ";\n  border-left: 0.4em solid\n    ", ";\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  transition: background 0.5s;\n  &:first-child {\n    border-top: ", ";\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  perspective: 1000px;\n"], ["\n  position: relative;\n  perspective: 1000px;\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  margin: 0;\n  opacity: ", ";\n  padding-left: 35%;\n  transition: all 0.5s;\n\n  @media screen and (min-width: ", ") {\n    padding-left: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding-left: ", ";\n    font-size: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding-left: ", ";\n    font-size: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    font-size: ", ";\n  }\n\n  a:hover & {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  margin: 0;\n  opacity: ", ";\n  padding-left: 35%;\n  transition: all 0.5s;\n\n  @media screen and (min-width: ", ") {\n    padding-left: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding-left: ", ";\n    font-size: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding-left: ", ";\n    font-size: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    font-size: ", ";\n  }\n\n  a:hover & {\n    color: ", ";\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: 1.1em;\n  font-weight: 300;\n  line-height: 1.2;\n  letter-spacing: \"-.02em\";\n  margin: 0.5rem 0 0 0;\n  padding-left: 35%;\n\n  @media screen and (min-width: ", ") {\n    padding-left: 33%;\n    font-size: 1.2em;\n  }\n  @media screen and (min-width: ", ") {\n    padding-left: 31%;\n    font-size: 1.3em;\n  }\n  @media screen and (min-width: ", ") {\n    padding-left: 29%;\n    font-size: 1.4em;\n  }\n  @media screen and (min-width: ", ") {\n    font-size: 1.5em;\n  }\n"], ["\n  color: ", ";\n  font-size: 1.1em;\n  font-weight: 300;\n  line-height: 1.2;\n  letter-spacing: \"-.02em\";\n  margin: 0.5rem 0 0 0;\n  padding-left: 35%;\n\n  @media screen and (min-width: ", ") {\n    padding-left: 33%;\n    font-size: 1.2em;\n  }\n  @media screen and (min-width: ", ") {\n    padding-left: 31%;\n    font-size: 1.3em;\n  }\n  @media screen and (min-width: ", ") {\n    padding-left: 29%;\n    font-size: 1.4em;\n  }\n  @media screen and (min-width: ", ") {\n    font-size: 1.5em;\n  }\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  bottom: 0;\n  width: 25%;\n  left: 3px;\n  position: absolute;\n  box-shadow: ", ";\n  overflow: hidden;\n  top: ", ";\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n\n  .gatsby-image-outer-wrapper {\n    height: 100%;\n  }\n  .gatsby-image-wrapper {\n    height: 100%;\n  }\n\n  @media (min-width: ", ") {\n    a:hover & {\n      ", ";\n    }\n  }\n"], ["\n  bottom: 0;\n  width: 25%;\n  left: 3px;\n  position: absolute;\n  box-shadow: ", ";\n  overflow: hidden;\n  top: ", ";\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n\n  .gatsby-image-outer-wrapper {\n    height: 100%;\n  }\n  .gatsby-image-wrapper {\n    height: 100%;\n  }\n\n  @media (min-width: ", ") {\n    a:hover & {\n      ", ";\n    }\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(176);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var wrapperShowUp = (0, _styledComponents.keyframes)(_templateObject);
	
	var Wrapper = _styledComponents2.default.nav(_templateObject2, function (props) {
	  return props.isAside ? props.inTransition ? "block" : "none" : "block";
	}, function (props) {
	  return props.theme.navigator.backgrounds.wrapper;
	}, function (props) {
	  return props.isAside ? function (props) {
	    return "-" + props.theme.navigator.sizes.asideWidth;
	  } : "0";
	}, function (props) {
	  return props.theme.topBar.sizes.height;
	}, function (props) {
	  return props.isAside ? props.theme.navigator.sizes.asideWidth : "100%";
	}, function (props) {
	  return props.theme.mediaQueryTresholds.M;
	}, function (props) {
	  return props.isAside ? function (props) {
	    return props.theme.topBar.sizes.height + 12;
	  } : function (props) {
	    return props.theme.topBar.sizes.height + 18;
	  };
	}, function (props) {
	  return props.theme.mediaQueryTresholds.L;
	}, function (props) {
	  return props.theme.navigator.colors.scrollTrack;
	}, function (props) {
	  return props.theme.navigator.colors.scrollThumb;
	}, function (props) {
	  return props.isAside ? "1em 1em 1em .8em" : "2em 1.5em";
	});
	
	var headerShowUp = (0, _styledComponents.keyframes)(_templateObject3);
	
	var Header = _styledComponents2.default.header(_templateObject4, function (props) {
	  return props.isAside ? "block" : "none";
	}, function (props) {
	  return props.theme.navigator.colors.header;
	});
	
	var List = _styledComponents2.default.ul(_templateObject5, function (props) {
	  return props.inTransition ? "none" : "block";
	}, function (props) {
	  return props.theme.navigator.sizes.maxWidth;
	}, function (props) {
	  return props.theme.mediaQueryTresholds.S;
	}, function (props) {
	  return !props.isAside ? "0 1.5em" : "";
	}, function (props) {
	  return props.theme.mediaQueryTresholds.M;
	}, function (props) {
	  return !props.isAside ? "0 2em" : "";
	}, function (props) {
	  return props.theme.mediaQueryTresholds.L;
	}, function (props) {
	  return !props.isAside ? "0 3em" : "";
	}, function (props) {
	  return props.theme.mediaQueryTresholds.XL;
	}, function (props) {
	  return !props.isAside ? "0" : "";
	});
	
	var itemShowUp = (0, _styledComponents.keyframes)(_templateObject6);
	
	var ListItem = _styledComponents2.default.li(_templateObject7, itemShowUp, function (props) {
	  return props.isActive ? function (props) {
	    return props.theme.navigator.backgrounds.asideItemActive;
	  } : "none";
	}, function (props) {
	  return props.isActive ? function (props) {
	    return props.theme.navigator.colors.asideItemActiveBorder;
	  } : props.theme.navigator.backgrounds.wrapper;
	}, function (props) {
	  return props.isAside ? "1px solid rgba(255, 255, 255, 0.1)" : "";
	});
	
	var Post = _styledComponents2.default.div(_templateObject8);
	
	var Title = _styledComponents2.default.h2(_templateObject9, function (props) {
	  return props.theme.navigator.colors.title;
	}, function (props) {
	  return props.isAside ? "400" : "700";
	}, function (props) {
	  return props.isAside ? ".95em" : "1.3em";
	}, function (props) {
	  return props.isAside ? "0" : "-.04em";
	}, function (props) {
	  return props.isAside ? "1.15" : "1.1";
	}, function (props) {
	  return props.inTransition ? "0" : "1";
	}, function (props) {
	  return props.theme.mediaQueryTresholds.S;
	}, function (props) {
	  return !props.isAside ? "33%" : "";
	}, function (props) {
	  return props.theme.mediaQueryTresholds.M;
	}, function (props) {
	  return !props.isAside ? "31%" : "";
	}, function (props) {
	  return !props.isAside ? "1.7em" : "";
	}, function (props) {
	  return props.theme.mediaQueryTresholds.L;
	}, function (props) {
	  return !props.isAside ? "29%" : "";
	}, function (props) {
	  return !props.isAside ? "2em" : "";
	}, function (props) {
	  return props.theme.mediaQueryTresholds.XL;
	}, function (props) {
	  return !props.isAside ? "2.2em" : "";
	}, function (props) {
	  return props.theme.navigator.colors.linkHover;
	});
	
	var SubTitle = _styledComponents2.default.h3(_templateObject10, function (props) {
	  return props.theme.navigator.colors.subTitle;
	}, function (props) {
	  return props.theme.mediaQueryTresholds.S;
	}, function (props) {
	  return props.theme.mediaQueryTresholds.M;
	}, function (props) {
	  return props.theme.mediaQueryTresholds.L;
	}, function (props) {
	  return props.theme.mediaQueryTresholds.XL;
	});
	
	var Picture = _styledComponents2.default.div(_templateObject11, function (props) {
	  return !props.isAside ? "0 2px 1px rgba(0,0,0,.2)" : "";
	}, function (props) {
	  return props.isAside ? "0" : "5px";
	}, function (props) {
	  return props.theme.mediaQueryTresholds.XL;
	}, function (props) {
	  return !props.isAside ? "\n      transform: rotateY(15deg) rotateX(-15deg) translateY(-20%);\n      box-shadow: 0 20px 10px -10px rgba(0,0,0,.2);\n      height: 150%;" : "";
	});
	
	var PostsNavigator = function (_React$Component) {
	  _inherits(PostsNavigator, _React$Component);
	
	  function PostsNavigator(props) {
	    _classCallCheck(this, PostsNavigator);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      isAside: false
	    };
	    return _this;
	  }
	
	  PostsNavigator.prototype.componentDidMount = function componentDidMount() {};
	
	  PostsNavigator.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      Wrapper,
	      {
	        isAside: this.props.isAside,
	        inTransition: this.props.inTransition,
	        isHidden: this.props.isHidden,
	        welcomeIsRolledUp: this.props.welcomeIsRolledUp
	      },
	      _react2.default.createElement(
	        Header,
	        { isAside: this.props.isAside },
	        "List of Posts: "
	      ),
	      _react2.default.createElement(
	        List,
	        {
	          isAside: this.props.isAside,
	          inTransition: this.props.inTransition
	        },
	        this.props.posts && this.props.posts.map(function (post) {
	          var title = post.node.frontmatter.title || post.node.path;
	          return _react2.default.createElement(
	            ListItem,
	            {
	              isActive: post.node.frontmatter.path === _this2.props.location,
	              isAside: _this2.props.isAside,
	              inTransition: _this2.props.inTransition,
	              key: post.node.frontmatter.path
	            },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                to: post.node.frontmatter.path,
	                onClick: _this2.props.linkOnClick
	              },
	              _react2.default.createElement(
	                Post,
	                null,
	                _react2.default.createElement(
	                  Picture,
	                  { isAside: _this2.props.isAside },
	                  _react2.default.createElement(_gatsbyImage2.default, {
	                    sizes: post.node.frontmatter.cover.children[0].sizes
	                  })
	                ),
	                _react2.default.createElement(
	                  Title,
	                  { isAside: _this2.props.isAside },
	                  post.node.frontmatter.title
	                ),
	                !_this2.props.isAside && _react2.default.createElement(
	                  SubTitle,
	                  { isAside: _this2.props.isAside },
	                  post.node.frontmatter.subTitle
	                )
	              )
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return PostsNavigator;
	}(_react2.default.Component);
	
	exports.default = PostsNavigator;
	module.exports = exports["default"];

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(18);
	
	var _store = __webpack_require__(29);
	
	var _PostsNavigator = __webpack_require__(151);
	
	var _PostsNavigator2 = _interopRequireDefault(_PostsNavigator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostsNavigatorContainer = function (_React$Component) {
	  _inherits(PostsNavigatorContainer, _React$Component);
	
	  function PostsNavigatorContainer(props) {
	    _classCallCheck(this, PostsNavigatorContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.linkOnClick = _this.linkOnClick.bind(_this);
	    return _this;
	  }
	
	  PostsNavigatorContainer.prototype.linkOnClick = function linkOnClick() {
	    var _this2 = this;
	
	    if (!this.props.isAside) {
	      this.props.setIsAside(true);
	      this.props.setInTransition(true);
	
	      setTimeout(function () {
	        _this2.props.setInTransition(false);
	      }, 800);
	    }
	  };
	
	  PostsNavigatorContainer.prototype.render = function render() {
	    return !!this.props.posts.length ? _react2.default.createElement(_PostsNavigator2.default, {
	      location: this.props.location,
	      posts: this.props.posts,
	      linkOnClick: this.linkOnClick,
	      isAside: this.props.isAside,
	      inTransition: this.props.inTransition,
	      isHidden: this.props.isHidden
	    }) : null;
	  };
	
	  return PostsNavigatorContainer;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    posts: state.posts,
	    isAside: state.navigator.isAside,
	    inTransition: state.navigator.inTransition,
	    isActive: state.posts.length
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setIsAside: function setIsAside(val) {
	      return dispatch((0, _store.setNavigatorIsAside)(val));
	    },
	    setInTransition: function setInTransition(val) {
	      return dispatch((0, _store.setNavigatorInTransition)(val));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PostsNavigatorContainer);
	module.exports = exports["default"];

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SVGelem = function SVGelem(props) {
	  //return props.icon;
	  return _react2.default.createElement(
	    "svg",
	    {
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink",
	      preserveAspectRatio: "xMidYMid meet",
	      viewBox: props.svg.viewBox,
	      width: "100%",
	      height: "100%"
	    },
	    props.svg.path
	  );
	};
	
	exports.default = SVGelem;
	module.exports = exports["default"];

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _siteConfig = __webpack_require__(21);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Seo = function (_Component) {
	  _inherits(Seo, _Component);
	
	  function Seo() {
	    _classCallCheck(this, Seo);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Seo.prototype.render = function render() {
	    var _props = this.props,
	        postNode = _props.postNode,
	        postPath = _props.postPath,
	        postSEO = _props.postSEO;
	
	    var title = void 0;
	    var description = void 0;
	    var image = void 0;
	    var postURL = void 0;
	    var realPrefix = _siteConfig2.default.pathPrefix === "/" ? "" : _siteConfig2.default.pathPrefix;
	    if (postSEO) {
	      var postMeta = postNode.frontmatter;
	      title = postMeta.title;
	      description = postNode.subTitle;
	      image = postMeta.cover.childImageSharp.resize.src;
	      postURL = _siteConfig2.default.siteUrl + realPrefix + postPath;
	    } else {
	      title = _siteConfig2.default.siteTitle;
	      description = _siteConfig2.default.siteDescription;
	      image = _siteConfig2.default.siteLogo;
	    }
	    image = _siteConfig2.default.siteUrl + realPrefix + image;
	    var blogURL = _siteConfig2.default.siteUrl + _siteConfig2.default.pathPrefix;
	    var schemaOrgJSONLD = [{
	      "@context": "http://schema.org",
	      "@type": "WebSite",
	      url: blogURL,
	      name: title,
	      alternateName: _siteConfig2.default.siteLongTitle ? _siteConfig2.default.siteLongTitle : ""
	    }];
	    if (postSEO) {
	      schemaOrgJSONLD.push([{
	        "@context": "http://schema.org",
	        "@type": "BreadcrumbList",
	        itemListElement: [{
	          "@type": "ListItem",
	          position: 1,
	          item: {
	            "@id": postURL,
	            name: title,
	            image: image
	          }
	        }]
	      }, {
	        "@context": "http://schema.org",
	        "@type": "BlogPosting",
	        url: blogURL,
	        name: title,
	        alternateName: _siteConfig2.default.siteTitleAlt ? _siteConfig2.default.siteTitleAlt : "",
	        headline: title,
	        image: {
	          "@type": "ImageObject",
	          url: image
	        },
	        description: description
	      }]);
	    }
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement("meta", { name: "description", content: description }),
	      _react2.default.createElement("meta", { name: "image", content: image }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify(schemaOrgJSONLD)
	      ),
	      _react2.default.createElement("meta", { property: "og:locale", content: "de_DE" }),
	      _react2.default.createElement("meta", { property: "og:site_name", content: _siteConfig2.default.ogSiteName }),
	      _react2.default.createElement("meta", { property: "og:url", content: postSEO ? postURL : blogURL }),
	      postSEO ? _react2.default.createElement("meta", { property: "og:type", content: "article" }) : null,
	      _react2.default.createElement("meta", { property: "og:title", content: title }),
	      _react2.default.createElement("meta", { property: "og:description", content: description }),
	      _react2.default.createElement("meta", { property: "og:image", content: image }),
	      _react2.default.createElement("meta", {
	        property: "fb:app_id",
	        content: _siteConfig2.default.siteFBAppID ? _siteConfig2.default.siteFBAppID : ""
	      }),
	      _react2.default.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
	      _react2.default.createElement("meta", {
	        name: "twitter:creator",
	        content: _siteConfig2.default.userTwitter ? _siteConfig2.default.userTwitter : ""
	      }),
	      _react2.default.createElement("meta", { name: "twitter:title", content: title }),
	      _react2.default.createElement("meta", { name: "twitter:url", content: _siteConfig2.default.siteUrl }),
	      _react2.default.createElement("meta", { name: "twitter:description", content: description }),
	      _react2.default.createElement("meta", { name: "twitter:image", content: image })
	    );
	  };
	
	  return Seo;
	}(_react.Component);
	
	exports.default = Seo;
	module.exports = exports["default"];

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  background: ", ";\n  box-shadow: ", ";\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n  height: ", "px;\n  justify-content: space-between;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  transition: all 0.6s ease;\n  z-index: 1;\n\n  @media screen and (min-width: ", ") {\n    height: ", "px;\n  }\n  @media screen and (min-width: ", ") {\n    left: ", ";\n  }\n"], ["\n  align-items: center;\n  background: ", ";\n  box-shadow: ", ";\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n  height: ", "px;\n  justify-content: space-between;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  transition: all 0.6s ease;\n  z-index: 1;\n\n  @media screen and (min-width: ", ") {\n    height: ", "px;\n  }\n  @media screen and (min-width: ", ") {\n    left: ", ";\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: block;\n  font-size: 1em;\n  font-weight: 700;\n  line-height: 1;\n  margin: 0.2em 0 0 1em;\n  text-transform: uppercase;\n  width: 240px;\n\n  svg path {\n    fill: ", ";\n  }\n"], ["\n  display: block;\n  font-size: 1em;\n  font-weight: 700;\n  line-height: 1;\n  margin: 0.2em 0 0 1em;\n  text-transform: uppercase;\n  width: 240px;\n\n  svg path {\n    fill: ", ";\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  padding: 10px;\n  transition: all 1s;\n\n  > span {\n    background: ", ";\n    color: ", ";\n    fill: currentColor;\n    border-radius: 100%;\n    display: block;\n    height: 24px;\n    width: 24px;\n    padding: 3px;\n  }\n\n  @media screen and (min-width: ", ") {\n    padding: 16px;\n  }\n"], ["\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  padding: 10px;\n  transition: all 1s;\n\n  > span {\n    background: ", ";\n    color: ", ";\n    fill: currentColor;\n    border-radius: 100%;\n    display: block;\n    height: 24px;\n    width: 24px;\n    padding: 3px;\n  }\n\n  @media screen and (min-width: ", ") {\n    padding: 16px;\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SVGelem = __webpack_require__(153);
	
	var _SVGelem2 = _interopRequireDefault(_SVGelem);
	
	var _constants = __webpack_require__(155);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var config = __webpack_require__(21);
	
	
	var Wrapper = _styledComponents2.default.header(_templateObject, function (props) {
	  return props.navigatorIsAside || !props.navigatorIsActive ? function (props) {
	    return props.theme.topBar.backgrounds.wrapperPost;
	  } : function (props) {
	    return props.theme.topBar.backgrounds.wrapper;
	  };
	}, function (props) {
	  return props.navigatorIsAside || !props.navigatorIsActive ? "0 1px 0px rgba(2, 2, 0, 0.05)" : "0 1px 1px rgba(2, 2, 0, 0.2)";
	}, function (props) {
	  return props.theme.topBar.sizes.height;
	}, function (props) {
	  return props.theme.mediaQueryTresholds.M;
	}, function (props) {
	  return props.theme.topBar.sizes.height + 12;
	}, function (props) {
	  return props.theme.mediaQueryTresholds.L;
	}, function (props) {
	  return props.navigatorIsAside ? function (props) {
	    return props.theme.navigator.sizes.asideWidth;
	  } : "0";
	});
	
	var Logo = _styledComponents2.default.span(_templateObject2, function (props) {
	  return props.navigatorIsAside || !props.navigatorIsActive ? function (props) {
	    return props.theme.topBar.colors.logoPost;
	  } : function (props) {
	    return props.theme.topBar.colors.logo;
	  };
	});
	
	var Btn = _styledComponents2.default.button(_templateObject3, function (props) {
	  return props.theme.topBar.backgrounds.icon;
	}, function (props) {
	  return props.theme.topBar.colors.link;
	}, function (props) {
	  return props.theme.mediaQueryTresholds.M;
	});
	
	var TopBar = function TopBar(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    {
	      navigatorIsAside: props.navigatorIsAside,
	      navigatorIsActive: props.navigatorIsActive
	    },
	    _react2.default.createElement(
	      Logo,
	      {
	        navigatorIsAside: props.navigatorIsAside,
	        navigatorIsActive: props.navigatorIsActive
	      },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/" },
	        _react2.default.createElement(_SVGelem2.default, { svg: _constants.LOGOS.TOP })
	      )
	    ),
	    _react2.default.createElement(
	      Btn,
	      { onClick: props.btnOnClick, "aria-label": "Unfold" },
	      _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(_SVGelem2.default, { svg: _constants.ICONS.INFO })
	      )
	    )
	  );
	};
	
	exports.default = TopBar;
	module.exports = exports["default"];

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(18);
	
	var _store = __webpack_require__(29);
	
	var _TopBar = __webpack_require__(278);
	
	var _TopBar2 = _interopRequireDefault(_TopBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopBarContainer = function (_React$Component) {
	  _inherits(TopBarContainer, _React$Component);
	
	  function TopBarContainer() {
	    _classCallCheck(this, TopBarContainer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TopBarContainer.prototype.render = function render() {
	    return _react2.default.createElement(_TopBar2.default, {
	      btnOnClick: this.props.btnOnClick,
	      navigatorIsAside: this.props.navigatorIsAside,
	      navigatorIsActive: this.props.navigatorIsActive
	    });
	  };
	
	  return TopBarContainer;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    navigatorIsAside: state.navigator.isAside,
	    navigatorIsActive: state.posts.length
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return { btnOnClick: function btnOnClick() {
	      return dispatch((0, _store.toggleInfoScreen)());
	    } };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TopBarContainer);
	module.exports = exports["default"];

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n  min-height: 100vh;\n"], ["\n  ", ";\n  min-height: 100vh;\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRedux = __webpack_require__(18);
	
	__webpack_require__(29);
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PostsNavigatorContainer = __webpack_require__(152);
	
	var _PostsNavigatorContainer2 = _interopRequireDefault(_PostsNavigatorContainer);
	
	var _InfoContainer = __webpack_require__(277);
	
	var _InfoContainer2 = _interopRequireDefault(_InfoContainer);
	
	var _TopBarContainer = __webpack_require__(279);
	
	var _TopBarContainer2 = _interopRequireDefault(_TopBarContainer);
	
	var _BottomBarContainer = __webpack_require__(275);
	
	var _BottomBarContainer2 = _interopRequireDefault(_BottomBarContainer);
	
	var _Seo = __webpack_require__(154);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	__webpack_require__(360);
	
	var _global = __webpack_require__(283);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _theme = __webpack_require__(284);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _base = __webpack_require__(282);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	//import whatInput from "what-input";
	
	
	var Container = _styledComponents2.default.div(_templateObject, _base2.default.baseStyles);
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template(props) {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	
	    return _react2.default.createElement(
	      _styledComponents.ThemeProvider,
	      { theme: _theme2.default },
	      _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	          _reactHelmet2.default,
	          null,
	          _react2.default.createElement("html", { lang: "en" })
	        ),
	        _react2.default.createElement(_Seo2.default, null),
	        _react2.default.createElement(_TopBarContainer2.default, null),
	        _react2.default.createElement(_InfoContainer2.default, null),
	        children(_extends({}, this.props)),
	        _react2.default.createElement(_PostsNavigatorContainer2.default, null),
	        _react2.default.createElement(_BottomBarContainer2.default, null)
	      )
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    posts: state.posts,
	    navigatorIsAside: state.navigator.isAside,
	    navigatorInTransition: state.navigator.inTransition
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return { btnOnClick: function btnOnClick() {
	      return dispatch(toggleInfoScreen());
	    } };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Template);
	module.exports = exports["default"];

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose([""], [""]);
	
	var _styledComponents = __webpack_require__(11);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = {
	  baseStyles: (0, _styledComponents.css)(_templateObject)
	};
	module.exports = exports["default"];

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	  first: "#BF4E28",
	  firstLight: "#E5AC27",
	  firstSuperLight: "#F6F7BE",
	  firstDark: "#665743",
	  firstDarkTransparent: "rgba(34, 34, 40, 0.4)", // "#665743",
	  accent: "#80BDA4",
	  bright: "#ffffff",
	  light: "#FFEC97",
	  middle: "#666666",
	  dark: "#333333",
	  superDark: "#111111"
	};

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n\n  * {\n    box-sizing: border-box;\n    -webkit-overflow-scrolling: touch;\n  }\n  body {\n    background: black url(", ") no-repeat fixed center;\n    font-family: \"-apple-system\",\n    \"BlinkMacSystemFont\",\n    \"Segoe UI\",\n    \"Roboto\",\n    \"Oxygen\",\n    \"Ubuntu\",\n    \"Cantarell\",\n    \"Fira Sans\",\n    \"Droid Sans\",\n    \"Helvetica Neue\",\n    \"sans-serif\";\n  }\n  \n  *::-webkit-scrollbar {\n    width: 6px;\n  }\n  *::-webkit-scrollbar-track {\n    background: #eee;\n  }\n  *::-webkit-scrollbar-thumb {\n    background-color: #ccc;\n  }\n\n  [data-whatintent=\"mouse\"] *:focus {\n    outline: none;\n  }\n  \n"], ["\n\n  * {\n    box-sizing: border-box;\n    -webkit-overflow-scrolling: touch;\n  }\n  body {\n    background: black url(", ") no-repeat fixed center;\n    font-family: \"-apple-system\",\n    \"BlinkMacSystemFont\",\n    \"Segoe UI\",\n    \"Roboto\",\n    \"Oxygen\",\n    \"Ubuntu\",\n    \"Cantarell\",\n    \"Fira Sans\",\n    \"Droid Sans\",\n    \"Helvetica Neue\",\n    \"sans-serif\";\n  }\n  \n  *::-webkit-scrollbar {\n    width: 6px;\n  }\n  *::-webkit-scrollbar-track {\n    background: #eee;\n  }\n  *::-webkit-scrollbar-thumb {\n    background-color: #ccc;\n  }\n\n  [data-whatintent=\"mouse\"] *:focus {\n    outline: none;\n  }\n  \n"]);
	
	var _styledComponents = __webpack_require__(11);
	
	var _DSCF = __webpack_require__(493);
	
	var _DSCF2 = _interopRequireDefault(_DSCF);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	(0, _styledComponents.injectGlobal)(_templateObject, _DSCF2.default);

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	var colors = __webpack_require__(55);
	
	var theme = {
	  navigator: {
	    colors: {
	      title: colors.firstSuperLight,
	      subTitle: colors.bright,
	      scrollTrack: colors.first,
	      scrollThumb: colors.firstDark,
	      linkHover: colors.bright,
	      header: colors.firstSuperLight,
	      asideItemActiveBorder: colors.accent
	    },
	    sizes: {
	      asideWidth: "19em",
	      maxWidth: "56em"
	    },
	    backgrounds: {
	      wrapper: colors.firstDarkTransparent,
	      asideItemActive: colors.firstDark
	    }
	  },
	  post: {
	    colors: {
	      author: colors.middle,
	      authorBorder: colors.firstLight,
	      bold: colors.middle,
	      blockquoteFrame: colors.light,
	      copyright: colors.middle,
	      link: colors.first,
	      linkHover: colors.firstLight,
	      meta: colors.middle,
	      metaBorder: colors.first,
	      text: colors.dark,
	      title: colors.middle,
	      subTitle: colors.superDark
	    },
	    backgrounds: {
	      wrapper: colors.bright,
	      meta: colors.light
	    },
	    sizes: {
	      maxWidth: "50em"
	    }
	  },
	  bottomBar: {
	    colors: {
	      link: colors.bright,
	      icon: colors.firstSuperLight
	    },
	    backgrounds: {
	      wrapper: colors.first,
	      icon: colors.firstDark
	    },
	    sizes: {
	      height: 44 //pixels
	    }
	  },
	  topBar: {
	    colors: {
	      logo: colors.bright,
	      logoPost: colors.first
	    },
	    backgrounds: {
	      wrapper: colors.first,
	      wrapperPost: colors.bright,
	      icon: colors.accent
	    },
	    sizes: {
	      height: 44 //pixels
	    }
	  },
	  info: {
	    colors: {
	      text: colors.firstLight,
	      link: colors.firstSuperLight,
	      linkHover: colors.first,
	      btn: colors.bright
	    },
	    backgrounds: {
	      wrapper: colors.firstDark,
	      btn: colors.accent
	    },
	    sizes: {
	      maxWidth: "40em"
	    }
	  },
	  mediaQueryTresholds: {
	    XL: "65em",
	    L: "49em",
	    M: "37em",
	    S: "28em",
	    XS: "21em"
	  }
	};
	
	exports.default = theme;
	module.exports = exports["default"];

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.ICONS = exports.LOGOS = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOGOS = exports.LOGOS = {
	  TOP: {
	    viewBox: "0 0 550 60",
	    path: _react2.default.createElement(
	      "g",
	      { fillRule: "evenodd" },
	      _react2.default.createElement("path", { d: "M524.241,55.969 C521.581,58.323 518.397,59.500 514.689,59.500 C510.437,59.417 506.810,57.608 503.807,54.073 L508.707,50.050 C509.514,50.825 510.441,51.484 511.490,52.029 C512.558,52.636 513.667,52.961 514.817,53.003 C516.974,53.003 518.708,52.385 520.019,51.151 C521.309,49.895 521.975,48.158 522.015,45.940 L522.015,42.614 C519.938,45.039 517.237,46.292 513.910,46.375 C511.874,46.333 510.180,45.885 508.829,45.030 C507.418,44.217 506.339,43.342 505.593,42.403 C504.766,41.340 504.172,40.037 503.809,38.494 C503.425,36.973 503.234,34.075 503.234,29.801 C503.234,25.443 503.425,22.494 503.809,20.951 C504.172,19.429 504.766,18.146 505.593,17.104 C506.339,16.089 507.418,15.177 508.829,14.369 C510.180,13.602 511.874,13.198 513.910,13.156 C517.035,13.156 519.737,14.437 522.015,17.000 L522.015,13.563 L528.322,13.563 L528.322,45.219 C528.241,50.094 526.881,53.677 524.241,55.969 ZM521.834,24.545 C521.652,23.563 521.299,22.768 520.774,22.162 C520.350,21.577 519.724,21.001 518.897,20.437 C518.069,19.957 517.040,19.695 515.808,19.653 C514.577,19.695 513.547,19.957 512.720,20.437 C511.852,21.001 511.206,21.577 510.782,22.162 C510.257,22.768 509.924,23.563 509.783,24.545 C509.621,25.527 509.541,27.283 509.541,29.813 C509.541,32.300 509.621,34.015 509.783,34.955 C509.924,35.938 510.257,36.753 510.782,37.401 C511.206,37.986 511.852,38.520 512.720,39.000 C513.547,39.585 514.577,39.878 515.808,39.878 C517.040,39.878 518.069,39.585 518.897,39.000 C519.724,38.520 520.350,37.986 520.774,37.401 C521.299,36.753 521.652,35.938 521.834,34.955 C521.955,34.015 522.015,32.300 522.015,29.813 C522.015,27.283 521.955,25.527 521.834,24.545 ZM488.158,42.219 C487.754,42.698 487.260,43.167 486.675,43.625 C486.151,44.146 485.475,44.594 484.648,44.969 C483.115,45.865 481.108,46.333 478.627,46.375 C476.226,46.333 474.260,45.865 472.726,44.969 C471.173,44.156 469.963,43.240 469.096,42.219 C467.926,40.906 467.058,39.354 466.493,37.563 C465.949,35.771 465.677,33.167 465.677,29.750 C465.677,26.327 465.949,23.698 466.494,21.861 C467.059,20.066 467.927,18.553 469.097,17.322 C469.965,16.244 471.176,15.280 472.729,14.431 C474.263,13.623 476.231,13.198 478.632,13.156 C481.114,13.198 483.122,13.625 484.656,14.437 C486.169,15.292 487.340,16.261 488.167,17.344 C489.414,18.573 490.299,20.083 490.823,21.875 C491.326,23.708 491.577,26.333 491.577,29.750 C491.577,33.167 491.325,35.771 490.821,37.563 C490.296,39.354 489.409,40.906 488.158,42.219 ZM484.967,24.733 C484.764,23.708 484.350,22.810 483.723,22.036 C483.258,21.305 482.571,20.730 481.660,20.312 C480.790,19.873 479.779,19.653 478.627,19.653 C477.555,19.653 476.564,19.873 475.654,20.312 C474.784,20.730 474.076,21.305 473.531,22.036 C472.984,22.810 472.590,23.709 472.347,24.733 C472.104,25.799 471.983,27.472 471.983,29.750 C471.983,32.008 472.104,33.659 472.347,34.704 C472.590,35.771 472.984,36.711 473.531,37.526 C474.076,38.153 474.784,38.708 475.654,39.188 C476.564,39.648 477.555,39.878 478.627,39.878 C479.779,39.878 480.790,39.648 481.660,39.188 C482.571,38.708 483.258,38.153 483.723,37.526 C484.350,36.711 484.764,35.771 484.967,34.704 C485.169,33.659 485.270,32.028 485.270,29.813 C485.270,27.492 485.169,25.799 484.967,24.733 ZM447.978,44.226 C446.405,43.022 445.619,40.999 445.619,38.156 L445.619,0.437 L451.926,0.437 L451.926,37.657 C451.926,39.138 452.715,39.878 454.293,39.878 L456.478,39.878 L456.478,46.000 L453.665,46.000 C451.366,46.000 449.471,45.409 447.978,44.226 ZM430.130,42.156 C429.263,43.406 428.124,44.406 426.712,45.156 C425.321,45.927 423.648,46.333 421.692,46.375 C418.386,46.292 415.684,45.039 413.587,42.614 L413.587,46.000 L407.280,46.000 L407.280,0.437 L413.587,0.437 L413.587,17.000 C414.736,15.854 415.997,14.917 417.369,14.187 C418.639,13.500 420.081,13.156 421.695,13.156 C425.547,13.261 428.360,14.677 430.135,17.406 C431.000,18.427 431.593,19.771 431.916,21.437 C432.217,23.083 432.368,25.854 432.368,29.750 C432.368,33.583 432.217,36.333 431.915,38.000 C431.592,39.750 430.997,41.136 430.130,42.156 ZM426.001,25.956 C425.859,24.807 425.587,23.740 425.184,22.757 C424.820,21.775 424.205,21.001 423.336,20.437 C422.468,19.915 421.288,19.653 419.794,19.653 C418.381,19.653 417.260,19.957 416.433,20.563 C415.565,21.169 414.929,21.963 414.525,22.946 C414.142,23.928 413.890,24.995 413.769,26.144 C413.648,27.294 413.587,28.496 413.587,29.750 C413.587,30.900 413.648,32.070 413.769,33.262 C413.890,34.475 414.142,35.572 414.525,36.554 C414.929,37.537 415.565,38.331 416.433,38.937 C417.260,39.564 418.381,39.878 419.794,39.878 C421.288,39.878 422.468,39.585 423.336,39.000 C424.205,38.394 424.820,37.621 425.184,36.680 C425.587,35.697 425.859,34.589 426.001,33.356 C426.041,32.186 426.062,30.983 426.062,29.750 C426.062,28.454 426.041,27.189 426.001,25.956 ZM367.853,0.062 L372.659,0.062 L372.659,46.375 L367.853,46.375 L367.853,0.062 ZM326.300,26.663 C326.300,24.389 325.715,22.658 324.544,21.468 C323.394,20.258 321.910,19.653 320.093,19.653 C318.276,19.653 316.783,20.258 315.612,21.468 C314.421,22.658 313.826,24.389 313.826,26.663 L313.826,46.000 L307.519,46.000 L307.519,13.563 L313.826,13.563 L313.826,17.000 L313.947,17.000 C316.023,14.437 318.745,13.156 322.112,13.156 C324.713,13.156 327.092,14.104 329.250,16.000 C331.387,17.917 332.506,20.729 332.607,24.437 L332.607,46.000 L326.300,46.000 L326.300,26.663 ZM287.243,13.563 L293.549,13.563 L293.549,46.000 L287.243,46.000 L287.243,13.563 ZM287.243,0.437 L293.549,0.437 L293.549,6.935 L287.243,6.935 L287.243,0.437 ZM271.567,42.156 C270.699,43.406 269.560,44.406 268.149,45.156 C266.758,45.927 265.084,46.333 263.129,46.375 C259.822,46.292 257.120,45.039 255.023,42.614 L255.023,46.000 L248.717,46.000 L248.717,0.437 L255.023,0.437 L255.023,17.000 C256.173,15.854 257.433,14.917 258.805,14.187 C260.075,13.500 261.517,13.156 263.131,13.156 C266.983,13.261 269.797,14.677 271.572,17.406 C272.436,18.427 273.030,19.771 273.352,21.437 C273.654,23.083 273.804,25.854 273.804,29.750 C273.804,33.583 273.653,36.333 273.351,38.000 C273.028,39.750 272.433,41.136 271.567,42.156 ZM267.437,25.956 C267.296,24.807 267.023,23.740 266.620,22.757 C266.257,21.775 265.641,21.001 264.773,20.437 C263.905,19.915 262.724,19.653 261.230,19.653 C259.817,19.653 258.697,19.957 257.869,20.563 C257.001,21.169 256.365,21.963 255.962,22.946 C255.578,23.928 255.326,24.995 255.205,26.144 C255.084,27.294 255.023,28.496 255.023,29.750 C255.023,30.900 255.084,32.070 255.205,33.262 C255.326,34.475 255.578,35.572 255.962,36.554 C256.365,37.537 257.001,38.331 257.869,38.937 C258.697,39.564 259.817,39.878 261.230,39.878 C262.724,39.878 263.905,39.585 264.773,39.000 C265.641,38.394 266.257,37.621 266.620,36.680 C267.023,35.697 267.296,34.589 267.437,33.356 C267.477,32.186 267.498,30.983 267.498,29.750 C267.498,28.454 267.477,27.189 267.437,25.956 ZM221.902,26.256 L227.118,26.663 C230.393,26.913 232.759,27.935 234.215,29.729 C235.570,31.481 236.247,33.703 236.247,36.394 C236.206,39.543 234.965,41.974 232.523,43.684 C230.100,45.437 227.001,46.333 223.227,46.375 C218.100,46.375 213.487,44.438 209.390,40.565 L213.794,36.093 C216.363,38.867 219.682,40.253 223.749,40.253 C225.570,40.253 227.057,39.889 228.210,39.159 C229.364,38.430 229.940,37.409 229.940,36.096 C229.940,34.930 229.597,34.117 228.909,33.659 C228.201,33.179 227.261,32.919 226.089,32.877 L220.508,32.377 C217.860,32.127 215.706,31.210 214.049,29.627 C212.350,28.085 211.480,25.929 211.440,23.157 C211.480,19.824 212.621,17.324 214.863,15.657 C217.044,13.990 219.811,13.156 223.163,13.156 C224.618,13.156 225.920,13.250 227.071,13.437 C228.222,13.646 229.303,13.937 230.312,14.312 C232.251,15.124 233.988,16.217 235.523,17.591 L231.610,22.307 C230.396,21.403 229.112,20.656 227.757,20.067 C226.422,19.542 224.886,19.278 223.146,19.278 C221.164,19.278 219.779,19.644 218.991,20.374 C218.162,21.104 217.747,22.042 217.747,23.189 C217.705,23.920 218.018,24.556 218.687,25.098 C219.293,25.703 220.365,26.089 221.902,26.256 ZM192.602,13.563 L198.908,13.563 L198.908,46.000 L192.602,46.000 L192.602,13.563 ZM192.602,0.437 L198.908,0.437 L198.908,6.935 L192.602,6.935 L192.602,0.437 ZM174.846,19.653 C173.230,19.653 171.846,20.196 170.694,21.280 C169.402,22.345 168.735,24.065 168.694,26.443 L168.694,46.000 L162.388,46.000 L162.388,13.563 L168.694,13.563 L168.694,17.000 L168.826,17.000 C170.905,14.437 173.631,13.156 177.002,13.156 C179.526,13.198 181.726,14.028 183.603,15.647 L178.997,21.283 C177.664,20.197 176.280,19.653 174.846,19.653 ZM146.899,42.156 C146.032,43.406 144.892,44.406 143.481,45.156 C142.090,45.927 140.417,46.333 138.461,46.375 C135.155,46.292 132.452,45.039 130.356,42.614 L130.356,46.000 L124.049,46.000 L124.049,0.437 L130.356,0.437 L130.356,17.000 C131.505,15.854 132.766,14.917 134.137,14.187 C135.408,13.500 136.850,13.156 138.464,13.156 C142.316,13.261 145.129,14.677 146.904,17.406 C147.769,18.427 148.362,19.771 148.684,21.437 C148.986,23.083 149.137,25.854 149.137,29.750 C149.137,33.583 148.986,36.333 148.683,38.000 C148.361,39.750 147.766,41.136 146.899,42.156 ZM142.770,25.956 C142.628,24.807 142.356,23.740 141.952,22.757 C141.589,21.775 140.973,21.001 140.105,20.437 C139.237,19.915 138.056,19.653 136.563,19.653 C135.150,19.653 134.029,19.957 133.202,20.563 C132.334,21.169 131.698,21.963 131.294,22.946 C130.910,23.928 130.658,24.995 130.537,26.144 C130.416,27.294 130.356,28.496 130.356,29.750 C130.356,30.900 130.416,32.070 130.537,33.262 C130.658,34.475 130.910,35.572 131.294,36.554 C131.698,37.537 132.334,38.331 133.202,38.937 C134.029,39.564 135.150,39.878 136.563,39.878 C138.056,39.878 139.237,39.585 140.105,39.000 C140.973,38.394 141.589,37.621 141.952,36.680 C142.356,35.697 142.628,34.589 142.770,33.356 C142.810,32.186 142.830,30.983 142.830,29.750 C142.830,28.454 142.810,27.189 142.770,25.956 ZM82.872,26.663 C82.872,24.389 82.286,22.658 81.115,21.468 C79.965,20.258 78.481,19.653 76.665,19.653 C74.848,19.653 73.354,20.258 72.184,21.468 C70.992,22.658 70.397,24.389 70.397,26.663 L70.397,46.000 L64.090,46.000 L64.090,13.563 L70.397,13.563 L70.397,17.000 L70.518,17.000 C72.595,14.437 75.316,13.156 78.684,13.156 C81.284,13.156 83.664,14.104 85.821,16.000 C87.958,17.917 89.077,20.729 89.178,24.437 L89.178,46.000 L82.872,46.000 L82.872,26.663 ZM47.889,42.219 C47.485,42.698 46.991,43.167 46.406,43.625 C45.882,44.146 45.206,44.594 44.379,44.969 C42.846,45.865 40.839,46.333 38.358,46.375 C35.958,46.333 33.991,45.865 32.458,44.969 C30.904,44.156 29.694,43.240 28.827,42.219 C27.657,40.906 26.789,39.354 26.225,37.563 C25.680,35.771 25.408,33.167 25.408,29.750 C25.408,26.327 25.680,23.698 26.225,21.861 C26.790,20.066 27.658,18.553 28.828,17.322 C29.696,16.244 30.907,15.280 32.461,14.431 C33.994,13.623 35.962,13.198 38.363,13.156 C40.845,13.198 42.853,13.625 44.387,14.437 C45.901,15.292 47.071,16.261 47.899,17.344 C49.146,18.573 50.030,20.083 50.554,21.875 C51.057,23.708 51.308,26.333 51.308,29.750 C51.308,33.167 51.056,35.771 50.552,37.563 C50.027,39.354 49.140,40.906 47.889,42.219 ZM44.698,24.733 C44.496,23.708 44.081,22.810 43.454,22.036 C42.989,21.305 42.302,20.730 41.392,20.312 C40.522,19.873 39.510,19.653 38.358,19.653 C37.286,19.653 36.295,19.873 35.385,20.312 C34.515,20.730 33.808,21.305 33.262,22.036 C32.715,22.810 32.321,23.709 32.079,24.733 C31.836,25.799 31.714,27.472 31.714,29.750 C31.714,32.008 31.836,33.659 32.079,34.704 C32.321,35.771 32.715,36.711 33.262,37.526 C33.808,38.153 34.515,38.708 35.385,39.188 C36.295,39.648 37.286,39.878 38.358,39.878 C39.510,39.878 40.522,39.648 41.392,39.188 C42.302,38.708 42.989,38.153 43.454,37.526 C44.081,36.711 44.496,35.771 44.698,34.704 C44.901,33.659 45.002,32.028 45.002,29.813 C45.002,27.492 44.901,25.799 44.698,24.733 ZM3.311,59.125 L0.833,59.125 L0.833,53.003 L2.619,53.003 C4.941,53.003 6.122,51.855 6.163,49.559 L6.163,13.563 L12.469,13.563 L12.469,50.031 C12.429,52.760 11.583,54.938 9.930,56.563 C8.238,58.229 6.031,59.083 3.311,59.125 ZM6.163,0.437 L12.469,0.437 L12.469,6.935 L6.163,6.935 L6.163,0.437 Z" })
	    )
	  },
	  MAIN: {
	    viewBox: "0 0 950 128",
	    path: _react2.default.createElement(
	      "g",
	      { fillRule: "evenodd" },
	      _react2.default.createElement("path", { d: "M886.633,62.434 L890.322,62.434 L890.322,72.000 L885.176,72.000 C881.713,72.000 878.880,70.895 876.678,68.683 C874.411,66.569 873.278,63.513 873.278,59.513 L873.278,29.124 L868.330,29.124 L868.330,21.316 L873.278,21.316 L873.278,5.887 L883.132,5.887 L883.132,21.316 L890.322,21.316 L890.322,29.124 L883.132,29.124 L883.132,58.674 C883.067,61.246 884.234,62.500 886.633,62.434 ZM840.326,66.580 L840.138,66.580 C836.892,70.584 832.655,72.586 827.426,72.586 C823.362,72.520 819.692,70.994 816.416,68.004 C812.856,65.081 811.044,60.760 810.981,55.041 L810.981,21.316 L820.835,21.316 L820.835,51.531 C820.835,54.954 821.765,57.627 823.627,59.550 C825.456,61.473 827.789,62.434 830.628,62.434 C833.466,62.434 835.785,61.473 837.583,59.550 C839.412,57.627 840.327,54.954 840.327,51.531 L840.327,21.316 L850.181,21.316 L850.181,72.000 L840.326,72.000 L840.326,66.580 ZM785.667,66.092 C785.036,66.841 784.264,67.573 783.350,68.289 C782.531,69.103 781.475,69.803 780.182,70.389 C777.787,71.789 774.651,72.520 770.774,72.586 C767.024,72.520 763.951,71.789 761.555,70.389 C759.128,69.119 757.237,67.687 755.882,66.092 C754.054,64.041 752.698,61.616 751.816,58.816 C750.965,56.017 750.540,51.948 750.540,46.609 C750.540,41.261 750.965,37.153 751.817,34.283 C752.700,31.479 754.055,29.114 755.884,27.190 C757.240,25.506 759.132,24.000 761.560,22.673 C763.956,21.410 767.031,20.746 770.783,20.682 C774.661,20.747 777.798,21.414 780.195,22.684 C782.560,24.019 784.388,25.532 785.681,27.225 C787.630,29.146 789.012,31.505 789.830,34.305 C790.616,37.170 791.009,41.271 791.009,46.609 C791.009,51.948 790.615,56.017 789.827,58.816 C789.008,61.616 787.621,64.041 785.667,66.092 ZM780.681,38.770 C780.365,37.170 779.717,35.765 778.737,34.556 C778.011,33.414 776.937,32.516 775.515,31.862 C774.155,31.177 772.575,30.833 770.774,30.833 C769.099,30.833 767.551,31.177 766.129,31.863 C764.770,32.516 763.665,33.414 762.812,34.556 C761.958,35.766 761.341,37.170 760.963,38.770 C760.583,40.436 760.394,43.049 760.394,46.609 C760.394,50.137 760.583,52.717 760.963,54.350 C761.341,56.016 761.958,57.486 762.812,58.760 C763.665,59.740 764.770,60.605 766.129,61.356 C767.551,62.075 769.099,62.434 770.774,62.434 C772.575,62.434 774.155,62.075 775.515,61.356 C776.937,60.605 778.011,59.740 778.737,58.760 C779.717,57.486 780.365,56.016 780.681,54.350 C780.997,52.717 781.155,50.169 781.155,46.707 C781.155,43.082 780.997,40.436 780.681,38.770 ZM728.780,65.994 C727.425,67.947 725.644,69.510 723.440,70.682 C721.266,71.886 718.651,72.520 715.596,72.586 C710.429,72.456 706.207,70.498 702.931,66.709 L702.931,72.000 L693.077,72.000 L693.077,0.809 L702.931,0.809 L702.931,26.688 C704.727,24.898 706.697,23.433 708.840,22.293 C710.825,21.219 713.078,20.682 715.600,20.682 C721.618,20.845 726.014,23.058 728.788,27.322 C730.139,28.918 731.066,31.017 731.569,33.621 C732.041,36.193 732.277,40.523 732.277,46.609 C732.277,52.599 732.040,56.896 731.568,59.500 C731.064,62.234 730.134,64.400 728.780,65.994 ZM722.328,40.681 C722.107,38.885 721.681,37.219 721.051,35.683 C720.483,34.148 719.521,32.940 718.165,32.058 C716.808,31.241 714.963,30.833 712.629,30.833 C710.422,30.833 708.671,31.307 707.378,32.254 C706.022,33.201 705.028,34.443 704.397,35.978 C703.798,37.513 703.404,39.179 703.215,40.975 C703.026,42.772 702.931,44.650 702.931,46.609 C702.931,48.406 703.026,50.235 703.215,52.096 C703.404,53.992 703.798,55.706 704.397,57.241 C705.028,58.776 706.022,60.017 707.378,60.964 C708.671,61.944 710.422,62.434 712.629,62.434 C714.963,62.434 716.808,61.977 718.165,61.063 C719.521,60.116 720.483,58.907 721.051,57.437 C721.681,55.902 722.107,54.171 722.328,52.244 C722.391,50.415 722.423,48.537 722.423,46.609 C722.423,44.585 722.391,42.609 722.328,40.681 ZM660.858,67.510 L660.669,67.510 C659.755,69.234 658.337,70.504 656.415,71.317 C654.523,72.163 651.908,72.586 648.568,72.586 C643.084,72.520 638.861,71.024 635.899,68.095 C632.779,65.230 631.219,61.569 631.219,57.110 C631.219,52.846 632.574,49.315 635.284,46.516 C637.994,43.651 641.965,42.187 647.197,42.122 L660.858,42.122 L660.858,36.774 C660.923,32.293 657.565,30.118 650.785,30.247 C648.325,30.247 646.387,30.509 644.968,31.032 C643.486,31.654 642.319,32.701 641.469,34.173 L633.713,28.062 C637.461,23.012 642.990,20.552 650.299,20.682 C656.473,20.617 661.403,21.821 665.089,24.295 C668.774,26.834 670.649,31.196 670.712,37.381 L670.712,72.000 L660.858,72.000 L660.858,67.510 ZM660.858,50.511 L649.015,50.511 C643.265,50.642 640.422,52.678 640.488,56.619 C640.488,58.346 641.229,59.811 642.714,61.017 C644.135,62.353 646.488,63.020 649.773,63.020 C653.909,63.086 656.831,62.581 658.536,61.506 C660.084,60.431 660.858,57.988 660.858,54.176 L660.858,50.511 ZM573.471,0.223 L580.982,0.223 L580.982,72.586 L573.471,72.586 L573.471,0.223 ZM508.546,41.785 C508.546,38.233 507.631,35.528 505.801,33.669 C504.004,31.779 501.685,30.833 498.847,30.833 C496.008,30.833 493.674,31.779 491.846,33.669 C489.984,35.528 489.054,38.233 489.054,41.785 L489.054,72.000 L479.200,72.000 L479.200,21.316 L489.055,21.316 L489.055,26.688 L489.243,26.688 C492.488,22.684 496.741,20.682 502.002,20.682 C506.065,20.682 509.783,22.163 513.155,25.125 C516.493,28.120 518.242,32.515 518.400,38.309 L518.400,72.000 L508.546,72.000 L508.546,41.785 ZM447.518,21.316 L457.372,21.316 L457.372,72.000 L447.518,72.000 L447.518,21.316 ZM447.518,0.809 L457.372,0.809 L457.372,10.960 L447.518,10.960 L447.518,0.809 ZM423.024,65.994 C421.669,67.947 419.889,69.510 417.684,70.682 C415.510,71.886 412.895,72.520 409.840,72.586 C404.673,72.456 400.451,70.498 397.175,66.709 L397.175,72.000 L387.321,72.000 L387.321,0.809 L397.175,0.809 L397.175,26.688 C398.971,24.898 400.941,23.433 403.084,22.293 C405.069,21.219 407.322,20.682 409.844,20.682 C415.863,20.845 420.259,23.058 423.032,27.322 C424.383,28.918 425.310,31.017 425.814,33.621 C426.285,36.193 426.521,40.523 426.521,46.609 C426.521,52.599 426.284,56.896 425.812,59.500 C425.308,62.234 424.378,64.400 423.024,65.994 ZM416.572,40.681 C416.351,38.885 415.925,37.219 415.295,35.683 C414.727,34.148 413.765,32.940 412.409,32.058 C411.052,31.241 409.207,30.833 406.874,30.833 C404.666,30.833 402.915,31.307 401.622,32.254 C400.266,33.201 399.272,34.443 398.641,35.978 C398.042,37.513 397.648,39.179 397.459,40.975 C397.270,42.772 397.175,44.650 397.175,46.609 C397.175,48.406 397.270,50.235 397.459,52.096 C397.648,53.992 398.042,55.706 398.641,57.241 C399.272,58.776 400.266,60.017 401.622,60.964 C402.915,61.944 404.666,62.434 406.874,62.434 C409.207,62.434 411.052,61.977 412.409,61.063 C413.765,60.116 414.727,58.907 415.295,57.437 C415.925,55.902 416.351,54.171 416.572,52.244 C416.635,50.415 416.667,48.537 416.667,46.609 C416.667,44.585 416.635,42.609 416.572,40.681 ZM345.423,41.150 L353.573,41.785 C358.691,42.177 362.388,43.774 364.663,46.577 C366.779,49.315 367.837,52.786 367.837,56.990 C367.774,61.912 365.835,65.709 362.018,68.381 C358.233,71.120 353.391,72.520 347.493,72.586 C339.482,72.586 332.275,69.560 325.872,63.508 L332.754,56.521 C336.769,60.854 341.954,63.020 348.309,63.020 C351.154,63.020 353.478,62.451 355.280,61.311 C357.082,60.172 357.983,58.577 357.983,56.525 C357.983,54.703 357.446,53.433 356.372,52.717 C355.266,51.967 353.797,51.561 351.965,51.495 L343.245,50.714 C339.107,50.323 335.743,48.891 333.152,46.417 C330.498,44.008 329.139,40.639 329.077,36.308 C329.139,31.100 330.922,27.193 334.425,24.589 C337.833,21.984 342.156,20.682 347.394,20.682 C349.666,20.682 351.701,20.828 353.500,21.121 C355.298,21.446 356.987,21.902 358.564,22.488 C361.593,23.756 364.307,25.465 366.706,27.611 L360.592,34.980 C358.695,33.567 356.688,32.400 354.572,31.480 C352.486,30.659 350.085,30.247 347.368,30.247 C344.271,30.247 342.106,30.818 340.874,31.959 C339.579,33.100 338.931,34.566 338.931,36.359 C338.865,37.500 339.355,38.494 340.400,39.341 C341.347,40.286 343.022,40.889 345.423,41.150 ZM299.641,21.316 L309.495,21.316 L309.495,72.000 L299.641,72.000 L299.641,21.316 ZM299.641,0.809 L309.495,0.809 L309.495,10.960 L299.641,10.960 L299.641,0.809 ZM271.898,30.833 C269.373,30.833 267.210,31.681 265.411,33.375 C263.391,35.039 262.349,37.727 262.286,41.443 L262.286,72.000 L252.432,72.000 L252.432,21.316 L262.286,21.316 L262.286,26.688 L262.492,26.688 C265.741,22.684 269.999,20.682 275.267,20.682 C279.210,20.747 282.648,22.044 285.581,24.573 L278.384,33.379 C276.301,31.682 274.139,30.833 271.898,30.833 ZM228.231,65.994 C226.876,67.947 225.096,69.510 222.891,70.682 C220.717,71.886 218.103,72.520 215.047,72.586 C209.880,72.456 205.658,70.498 202.382,66.709 L202.382,72.000 L192.528,72.000 L192.528,0.809 L202.382,0.809 L202.382,26.688 C204.178,24.898 206.148,23.433 208.291,22.293 C210.276,21.219 212.529,20.682 215.051,20.682 C221.070,20.845 225.466,23.058 228.239,27.322 C229.590,28.918 230.517,31.017 231.021,33.621 C231.492,36.193 231.728,40.523 231.728,46.609 C231.728,52.599 231.491,56.896 231.019,59.500 C230.515,62.234 229.586,64.400 228.231,65.994 ZM221.779,40.681 C221.558,38.885 221.132,37.219 220.502,35.683 C219.934,34.148 218.972,32.940 217.616,32.058 C216.259,31.241 214.414,30.833 212.081,30.833 C209.873,30.833 208.122,31.307 206.829,32.254 C205.473,33.201 204.479,34.443 203.849,35.978 C203.249,37.513 202.855,39.179 202.666,40.975 C202.477,42.772 202.382,44.650 202.382,46.609 C202.382,48.406 202.477,50.235 202.666,52.096 C202.855,53.992 203.249,55.706 203.849,57.241 C204.479,58.776 205.473,60.017 206.829,60.964 C208.122,61.944 209.873,62.434 212.081,62.434 C214.414,62.434 216.259,61.977 217.616,61.063 C218.972,60.116 219.934,58.907 220.502,57.437 C221.132,55.902 221.558,54.171 221.779,52.244 C221.842,50.415 221.874,48.537 221.874,46.609 C221.874,44.585 221.842,42.609 221.779,40.681 ZM128.188,41.785 C128.188,38.233 127.273,35.528 125.444,33.669 C123.646,31.779 121.328,30.833 118.490,30.833 C115.651,30.833 113.317,31.779 111.488,33.669 C109.627,35.528 108.697,38.233 108.697,41.785 L108.697,72.000 L98.842,72.000 L98.842,21.316 L108.697,21.316 L108.697,26.688 L108.886,26.688 C112.131,22.684 116.383,20.682 121.644,20.682 C125.708,20.682 129.426,22.163 132.797,25.125 C136.136,28.120 137.884,32.515 138.042,38.309 L138.042,72.000 L128.188,72.000 L128.188,41.785 ZM73.528,66.092 C72.897,66.841 72.125,67.573 71.211,68.289 C70.392,69.103 69.336,69.803 68.044,70.389 C65.648,71.789 62.512,72.520 58.636,72.586 C54.885,72.520 51.812,71.789 49.416,70.389 C46.989,69.119 45.098,67.687 43.743,66.092 C41.915,64.041 40.559,61.616 39.677,58.816 C38.826,56.017 38.401,51.948 38.401,46.609 C38.401,41.261 38.827,37.153 39.678,34.283 C40.561,31.479 41.917,29.114 43.745,27.190 C45.101,25.506 46.993,24.000 49.421,22.673 C51.817,21.410 54.892,20.746 58.644,20.682 C62.522,20.747 65.659,21.414 68.057,22.684 C70.421,24.019 72.250,25.532 73.543,27.225 C75.491,29.146 76.874,31.505 77.692,34.305 C78.478,37.170 78.870,41.271 78.870,46.609 C78.870,51.948 78.476,56.017 77.689,58.816 C76.869,61.616 75.482,64.041 73.528,66.092 ZM68.543,38.770 C68.226,37.170 67.578,35.765 66.599,34.556 C65.872,33.414 64.798,32.516 63.376,31.862 C62.016,31.177 60.436,30.833 58.636,30.833 C56.960,30.833 55.412,31.177 53.990,31.863 C52.631,32.516 51.526,33.414 50.673,34.556 C49.819,35.766 49.203,37.170 48.824,38.770 C48.444,40.436 48.255,43.049 48.255,46.609 C48.255,50.137 48.444,52.717 48.824,54.350 C49.203,56.016 49.819,57.486 50.673,58.760 C51.526,59.740 52.631,60.605 53.990,61.356 C55.412,62.075 56.960,62.434 58.636,62.434 C60.436,62.434 62.016,62.075 63.376,61.356 C64.798,60.605 65.872,59.740 66.599,58.760 C67.578,57.486 68.226,56.016 68.543,54.350 C68.858,52.717 69.016,50.169 69.016,46.707 C69.016,43.082 68.858,40.436 68.543,38.770 ZM3.875,92.508 L0.003,92.508 L0.003,82.942 L2.794,82.942 C6.422,82.942 8.267,81.148 8.331,77.561 L8.331,21.316 L18.185,21.316 L18.185,78.299 C18.122,82.563 16.799,85.965 14.218,88.504 C11.573,91.108 8.126,92.442 3.875,92.508 ZM8.331,0.809 L18.185,0.809 L18.185,10.960 L8.331,10.960 L8.331,0.809 Z" })
	    )
	  }
	};
	
	var ICONS = exports.ICONS = {
	  HOME: {
	    viewBox: "0 0 13 14",
	    path: _react2.default.createElement("path", { d: "M11 7.75v3.75q0 0.203-0.148 0.352t-0.352 0.148h-3v-3h-2v3h-3q-0.203 0-0.352-0.148t-0.148-0.352v-3.75q0-0.008 0.004-0.023t0.004-0.023l4.492-3.703 4.492 3.703q0.008 0.016 0.008 0.047zM12.742 7.211l-0.484 0.578q-0.062 0.070-0.164 0.086h-0.023q-0.102 0-0.164-0.055l-5.406-4.508-5.406 4.508q-0.094 0.062-0.187 0.055-0.102-0.016-0.164-0.086l-0.484-0.578q-0.062-0.078-0.055-0.184t0.086-0.168l5.617-4.68q0.25-0.203 0.594-0.203t0.594 0.203l1.906 1.594v-1.523q0-0.109 0.070-0.18t0.18-0.070h1.5q0.109 0 0.18 0.070t0.070 0.18v3.188l1.711 1.422q0.078 0.062 0.086 0.168t-0.055 0.184z" })
	  },
	  ARROW_LEFT: {
	    viewBox: "0 0 13 14",
	    path: _react2.default.createElement("path", { d: "M12 7v1q0 0.414-0.254 0.707t-0.66 0.293h-5.5l2.289 2.297q0.297 0.281 0.297 0.703t-0.297 0.703l-0.586 0.594q-0.289 0.289-0.703 0.289-0.406 0-0.711-0.289l-5.086-5.094q-0.289-0.289-0.289-0.703 0-0.406 0.289-0.711l5.086-5.078q0.297-0.297 0.711-0.297 0.406 0 0.703 0.297l0.586 0.578q0.297 0.297 0.297 0.711t-0.297 0.711l-2.289 2.289h5.5q0.406 0 0.66 0.293t0.254 0.707z" })
	  },
	  CHEVRON_DOWN: {
	    viewBox: "0 0 14 14",
	    path: _react2.default.createElement("path", { d: "M13.148 6.312l-5.797 5.789q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.789q-0.148-0.148-0.148-0.355t0.148-0.355l1.297-1.289q0.148-0.148 0.352-0.148t0.352 0.148l4.148 4.148 4.148-4.148q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.289q0.148 0.148 0.148 0.355t-0.148 0.355z" })
	  },
	  INFO: {
	    viewBox: "0 0 5 14",
	    path: _react2.default.createElement("path", { d: "M5 10.5v1q0 0.203-0.148 0.352t-0.352 0.148h-4q-0.203 0-0.352-0.148t-0.148-0.352v-1q0-0.203 0.148-0.352t0.352-0.148h0.5v-3h-0.5q-0.203 0-0.352-0.148t-0.148-0.352v-1q0-0.203 0.148-0.352t0.352-0.148h3q0.203 0 0.352 0.148t0.148 0.352v4.5h0.5q0.203 0 0.352 0.148t0.148 0.352zM4 1.5v1.5q0 0.203-0.148 0.352t-0.352 0.148h-2q-0.203 0-0.352-0.148t-0.148-0.352v-1.5q0-0.203 0.148-0.352t0.352-0.148h2q0.203 0 0.352 0.148t0.148 0.352z" })
	  },
	  SIGN_IN: {
	    viewBox: "0 0 12 14",
	    path: _react2.default.createElement("path", { d: "M9.25 7q0 0.203-0.148 0.352l-4.25 4.25q-0.148 0.148-0.352 0.148t-0.352-0.148-0.148-0.352v-2.25h-3.5q-0.203 0-0.352-0.148t-0.148-0.352v-3q0-0.203 0.148-0.352t0.352-0.148h3.5v-2.25q0-0.203 0.148-0.352t0.352-0.148 0.352 0.148l4.25 4.25q0.148 0.148 0.148 0.352zM12 4.25v5.5q0 0.93-0.66 1.59t-1.59 0.66h-2.5q-0.102 0-0.176-0.074t-0.074-0.176q0-0.031-0.008-0.156t-0.004-0.207 0.023-0.184 0.078-0.152 0.16-0.051h2.5q0.516 0 0.883-0.367t0.367-0.883v-5.5q0-0.516-0.367-0.883t-0.883-0.367h-2.438t-0.090-0.008-0.090-0.023-0.062-0.043-0.055-0.070-0.016-0.105q0-0.031-0.008-0.156t-0.004-0.207 0.023-0.184 0.078-0.152 0.16-0.051h2.5q0.93 0 1.59 0.66t0.66 1.59z" })
	  },
	  CLOSE: {
	    viewBox: "0 0 11 14",
	    path: _react2.default.createElement("path", { d: "M10.141 10.328q0 0.312-0.219 0.531l-1.062 1.062q-0.219 0.219-0.531 0.219t-0.531-0.219l-2.297-2.297-2.297 2.297q-0.219 0.219-0.531 0.219t-0.531-0.219l-1.062-1.062q-0.219-0.219-0.219-0.531t0.219-0.531l2.297-2.297-2.297-2.297q-0.219-0.219-0.219-0.531t0.219-0.531l1.062-1.062q0.219-0.219 0.531-0.219t0.531 0.219l2.297 2.297 2.297-2.297q0.219-0.219 0.531-0.219t0.531 0.219l1.062 1.062q0.219 0.219 0.219 0.531t-0.219 0.531l-2.297 2.297 2.297 2.297q0.219 0.219 0.219 0.531z" })
	  }
	};

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var colors = __webpack_require__(55);
	
	module.exports = {
	  pathPrefix: "/",
	  siteTitle: "jon brisbin | home",
	  siteLongTitle: "Web home for Software Engineer and Writer Jon Brisbin",
	  siteUrl: "https://jbrisbin.com/",
	  siteLanguage: "en",
	  siteLogo: "/logos/logo-1024.png",
	  siteDescription: "This is a starter/theme for GatsbyJS",
	  // manifest.json
	  manifestName: "StyledBlog Gatsby starter",
	  manifestShortName: "StyledBlog",
	  manifestStartUrl: "/",
	  manifestBackgroundColor: colors.first,
	  manifestThemeColor: colors.firstLight,
	  manifestDisplay: "standalone",
	  // analytics
	  analyticsTrackingId: "UA-27843911-1",
	  // author note
	  authorName: "Jon Brisbin",
	  authorDescription: "is a Husband and Father by choice, a Writer by trade, a Software Engineer by profession, and a follower of Jesus by an act of Unmerited Grace. He lives, works, and writes from the Rural American Midwest.",
	  // texts
	  copyright: "(c) 2000-2018 by Jon Brisbin. All rights reserved."
	};

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/DSCF3950.da2e57d5.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-d24b1ad23901cc93e846.js